// typeDetail
$(document).ready(function () {
  if ($('body').hasClass('type-detail')) {
    $('.add-to-cart-button').html('Vložit do košíku')
    $('.p-detail-tabs-wrapper').insertAfter('#product-detail-form')



    $('#ratingWrapper').append($('#ratingWrapper .add-comment'));

    $('#ratingsList .vote-wrap').each(function () {
      $(this).append($(this).find('.vote-summary .vote-rating'));

    });

    // wrapper
    $('a.shp-tab-link:contains(\'Hodnocení\')').html('Recenze')
    $('.add-comment .link-like').html('Přidat recenzi')

    $('.stars-label').each(function () {
      $(this).text($(this).text().replace('hodnocení', 'recenze'))
    })



    $('.add-to-cart').append($('.p-final-price-wrapper'));


    if ($('.detail-wrapper .availability-value').length === 0) {
      $('.add-to-cart').append($('.availability-value'));
    }



    $('.p-info-wrapper').prepend($('.p-detail-inner .p-detail-inner-header').clone())
    $('.p-info-wrapper').after($('.p-detail-info'))

    $('.delivery-time-label a.shipping-options').appendTo('.p-info-wrapper .availability-value')

    // breadcrumbs
    let textBedYes = $('.breadcrumbs span:contains(\'Postele\')')
    if (textBedYes.length > 0) {
      $('body').addClass('pageBedYes')
    }

    // deliveryTime
    const $spanElement = $('th > span.delivery-time-label')

    if ($spanElement.length && $.trim($spanElement.text()) !== '') {
      $spanElement.closest('tr').addClass('delivery-time-label')
    }

    // moreniYes
    $('th:contains(\'Moření\')').parent().addClass('moreniYes')

    if ($('body.type-detail .p-detail-info .flag-popisne-parametry').length) {
      $('body').addClass('flag-popisne-parametry')
    }

    $('div#description .extended-description .detail-parameters th span:contains(\'Kategorie\')')
      .parent()
      .parent()
      .addClass('disable-span')
    $('.p-short-description div.table').insertAfter('.text-widget')
    $('.extended-description>h3:nth-of-type(1)').hide()

    $('<div class="form"></div><div id="formBox"></div>').insertAfter(
      'form#product-detail-form'
    )

    $(function () {
      $('#ratingWrapper').insertAfter('.p-detail-tabs-wrapper')
      $('#ratingTab').appendTo('.p-detail-inner')
      $('#discussionWrapper').appendTo('.p-detail-inner')
      $('<h2 class="discussion">Diskuze k produktu</h2>').prependTo('#discussionWrapper')
    })

    // rateList
    $('#ratingWrapper .rate-list').each(function () {
      var score = $(this).data('score'),
        $stars = $(this).find('.rate-star.stars')

      $stars.empty()

      for (var i = 0; i < score; i++) {
        $stars.append('<span class="star star-off"></span>')
      }
    })

    $('#ratingWrapper').append(`
  <section class="customer-appreciation">
    <h2 class="customer-appreciation__title">
      Co na nás zákazníci oceňují nejvíce?
    </h2>
    <div class="customer-appreciation__grid">
      <div class="feature">
        <span class="feature__icon" aria-hidden="true"><img src="/user/documents/upload/temp/check_1.png" alt="" />️</span>
        <div class="feature__content">
          <h3 class="feature__heading">Rychlost doručení</h3>
          <p class="feature__text">Doručujeme do dvou pracovních dní</p>
        </div>
      </div>

      <div class="feature">
        <span class="feature__icon" aria-hidden="true"><img src="/user/documents/upload/temp/check_1.png" alt="" />️</span>
        <div class="feature__content">
          <h3 class="feature__heading">Kvalita zboží</h3>
          <p class="feature__text">Produkty od českých výrobců</p>
        </div>
      </div>

      <div class="feature">
        <span class="feature__icon" aria-hidden="true"><img src="/user/documents/upload/temp/check_1.png" alt="" />️</span>
        <div class="feature__content">
          <h3 class="feature__heading">Ochota a komunikace</h3>
          <p class="feature__text">Poradíme, když si nevíte rady</p>
        </div>
      </div>

      <div class="feature">
        <span class="feature__icon" aria-hidden="true"><img src="/user/documents/upload/temp/check_1.png" alt="" /></span>
        <div class="feature__content">
          <h3 class="feature__heading">Výběr zboží</h3>
          <p class="feature__text">Široký sortiment pro lepší spánek</p>
        </div>
      </div>
    </div>
  </section>
  <img class="heureka-widget" src="/user/documents/upload/temp/heureka_1.png" alt="" />
`)

    // rateCountActive
    $('.rate-block', this).each(function () {
      $(this).find('.rate-bar .rate-count.active').appendTo($(this))
    })

  }

  // min768px
  if ($('.type-detail').length && window.matchMedia('(max-width: 768px)').matches) {
    $(
      '<img class="quality-banner" src="https://www.vyspimese.cz/user/documents/upload/temp/detail/banner-detail-product.png" alt="" />'
    ).insertAfter('.add-to-cart')
  }

  // max768px
  if ($('.type-detail').length && window.matchMedia('(min-width: 767px)').matches) {
    $(
      '<img class="quality-banner" src="https://www.vyspimese.cz/user/documents/upload/temp/detail/banner-detail-product.png" alt="" />'
    ).appendTo('.p-image-wrapper')
  }
})

// typeDetail
// jsonLD
$(window).on('load', function () {
  if ($('body').hasClass('type-detail') && $('body').hasClass('matrace-detail')) {
    $(`<ul class="benefit-product">
      <li><strong>Naše matrace se jen tak neproleží</strong>, minimum reklamací je toho důkazem</li>
      <li>Dokonale <strong>známe každou nabízenou matraci</strong></li>
      <li><strong>Osobně testujeme</strong> a kontrolujeme kvalitu dodavatelů</li>
      <li>Jsme <strong>přední prodejci</strong> nejznámějších výrobců</li>
      <li>Vyrobíme pro vás <a href="https://www.vyspimese.cz/form-matrace-na-miru/" target="_blank">matraci na míru</a></li>
    </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('postele')) {
    $(`<ul class="benefit-product">
    <li>Poctivé masivní postele ze srdce ČR vydrží celý život</li>
    <li>Osobně testujeme a kontrolujeme kvalitu postelí ve výrobě</li>
    <li>Postelím rozumíme - máme 4 kamenné prodejny a nadstandardní servis</li>
    <li>Jsme přední prodejci nejznámějších českých výrobců</li>
    <li>Vyrobíme pro vás <a href="https://www.vyspimese.cz/form-postele-na-miru/" target="_blank">postel na míru</a></li>
  </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('rosty')) {
    $(`<ul class="benefit-product">
    <li>Prodlužte životnost matrace kvalitním roštem z ČR</li>
    <li>Osobně testujeme a kontrolujeme kvalitu ve výrobě</li>
    <li>Roštům rozumíme - máme 4 kamenné prodejny a nadstandardní servis</li>
    <li>Naše rošty se přizpůsobí každému pohybu vašeho těla</li>
    <li>Vyrobíme pro vás <a href="https://www.vyspimese.cz/form-rosty-na-miru/" target="_blank">rošt na míru</a></li>
  </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('in-nabytek-2')) {
    $(`<ul class="benefit-product">
    <li>Kvalitní dřevo, nadčasový design</li>
    <li>Ruční práce, která vydrží generace</li>
    <li>Výrobce osobně dobře známe</li>
    <li>Luxusní vzhled za férovou cenu</li>
    <li>Pro kvalitní spánek</li>
  </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('polstare-detail')) {
    $(`<ul class="benefit-product">
    <li>Dopřejte si kvalitní spánek bez převalování</li>
    <li>Ranní vstávání bez bolesti krku</li>
    <li>100% záruka spokojenosti</li>
    <li>Testováno pro lepší rána</li>
    <li>Pečlivě vybraný sortiment od prověřených výrobců</li>
  </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('prikryvky-detail')) {
    $(`<ul class="benefit-product">
    <li>Hypoalergenní materiály - ideální pro citlivou pokožku a alergiky</li>
    <li>Probuďte se svěží a odpočatí - každý den</li>
    <li>Prémiová výplň pro maximální pohodlí a dlouhou životnost</li>
    <li>Konec probouzení v noci - teplota vždy přesně podle vás</li>
    <li>Pečlivě vybraný sortiment od prověřených výrobců</li>
  </ul>`).insertAfter('.quality-banner')
  }

  if ($('body').hasClass('type-detail') && $('body').hasClass('luzkoviny-detail')) {
    $(`<ul class="benefit-product">
    <li>Materiály, které dýchají a udrží ideální teplotu celou noc</li>
    <li>Lůžkoviny, ve kterých usnete dřív než dočtete tuhle větu</li>
    <li>Cenově dostupné, ale nepřekonatelně v pohodlí</li>
    <li>Snadná údržba a dlouhá životnost</li>
    <li>Pečlivě vybraný sortiment od prověřených výrobců</li>
  </ul>`).insertAfter('.quality-banner')
  }
})

// CallbackBox
$(window).on('load', function () {
  if ($('body').hasClass('type-detail')) {
    const productName = $('.p-detail-inner-header h1').text().trim()
    const formId = $('input[name="formId"]').val() || '10'
    const productId = $('input[name="productId"]').val() || '00000'

    const callbackBox = `
      <div class="callback-box">
        <div class="callback-content">
          <div class="agent-photo">
            <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/contact.svg" alt="contact" />
            <span class="online-status">
              <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/on-line.svg" alt="on-line" />
            </span>
          </div>
          <div class="callback-form">
            <h3>Potřebujete poradit s výběrem?</h3>
            <p>Nechte nám na sebe číslo. Zavoláme vám a se vším poradíme</p>

            <form action="/action/MailForm/sendProductQuestion/" method="post" id="formProductQuestion">
              <input type="hidden" name="formId" value="${formId}" />
              <input type="hidden" name="productId" value="${productId}" />

              <div class="form-group js-validated-element-wrapper">
                <label for="email"><span class="required-asterisk">Váš e-mail</span></label>
                <input type="email" name="email" id="email" class="form-control" value="info@vyspimese.cz" required />
                <span class="no-display">Nevyplňujte toto pole:</span>
                <input type="text" name="surname" class="no-display" />
              </div>

              <div class="form-group js-validated-element-wrapper">
                <label for="phone">Telefon</label>
                <input type="text" value="" name="phone" id="phone" class="form-control" placeholder="+420 123 456 789" required>
              </div>

              <div class="form-group">
                <label for="message"><span class="required-asterisk">Zpráva</span></label>
                <textarea name="message" id="message" rows="7" class="form-control" required>Prosím, kontaktujte mě ohledně produktu: ${productName}</textarea>
              </div>

              <div class="form-group js-validated-element-wrapper consents consents-first">
                <input type="hidden" name="consents[]" id="consents40" value="40" data-special-message="validatorConsent" />
                <label for="consents40" class="whole-width">
                  Vložením zprávy souhlasíte s
                  <a href="/podminky-ochrany-osobnich-udaju/" rel="noopener noreferrer" target="_blank">podmínkami ochrany osobních údajů</a>
                </label>
              </div>

              <div class="form-group submit-wrapper">
                <input type="submit" value="ZAVOLEJTE MI" class="btn btn-primary" />
              </div>
            </form>
          </div>
        </div>
        <div class="guarantee-box">
          <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/badge.svg" alt="badge" />
          <div>
            <strong>U nás nakupujte bez starostí</strong>
            <p>Autorizovaný prodejce všech značek. 100% záruka. Záruční i pozáruční servis.</p>
          </div>
        </div>
      </div>
    `

    $(callbackBox).insertAfter('.p-image')

    // === Dynamické doplňování telefonu do zprávy ===
    $(document).on('input', '#phone', function () {
      const phone = $(this).val().trim()
      const message = `Prosím, kontaktujte mě ohledně produktu: ${productName}`
      $('#message').val(phone ? `${message}\nTelefon: ${phone}` : message)
    })

    // === Validace: musí být vyplněn telefon ===
    $(document).on('submit', '#formProductQuestion', function (e) {
      const phone = $('#phone').val().trim()
      if (!phone) {
        e.preventDefault()
        alert('Vyplňte prosím telefonní číslo.')
      }
    })
  }
})


// extendedDescription
$(window).on('load', function () {
  if ($(window).width() <= 768 && $('body').hasClass('type-detail')) {
    //const table = $('.extended-description .table')
    const tabs = $('.shp-tabs-wrapper.p-detail-tabs-wrapper')

    /*if (table.length > 0 && tabs.length > 0) {
      table.insertBefore(tabs)
    }*/
  }

  if ($(window).width() > 768) {
    if ($('.p-info-wrapper').length) {
      $('.availability-value, .p-final-price-wrapper, .add-to-cart').wrapAll(
        '<div class="detail-wrapper"></div>'
      )
    }
  }

  // freeShipingInBody
  let priceTextElement = $('.type-detail .price-final')

  if (priceTextElement.length) {
    let priceText = priceTextElement.text().replace(/\s/g, '').replace(',', '.') // Odstraní mezery, převede desetinnou čárku na tečku
    let price = parseFloat(priceText.match(/[\d.]+/)) // Extrahuje číselnou hodnotu včetně desetinných míst

    if (!isNaN(price) && price >= 4000) {
      $('body').addClass('free-traffic').removeClass('no-free-traffic')
    } else {
      $('body').addClass('no-free-traffic').removeClass('free-traffic')
    }
  }

  // freeShiping
  if ($('body').hasClass('type-detail') && $('body').hasClass('free-traffic')) {
    let availabilityElement = $('.availability-value')

    if (availabilityElement.length) {
      $(
        '<div class="free-shipping"><span>Tento produkt vám doručíme <strong>ZDARMA</strong></span></div>'
      ).insertAfter(availabilityElement)
    }

    if ($('.detail-wrapper .free-shipping').length === 0) {
      $('.add-to-cart').append($('.free-shipping'));
    }

  }






  // benefitProduct
  if ($('body').hasClass('type-detail')) {
    $('.benefitBanner.position--benefitProduct').insertBefore('.shp-tabs-wrapper.p-detail-tabs-wrapper')
  }
})


// header#header
// reviewSummary
// min991
$(document).ready(function () {
  let cachedReviewCount = null

  function fetchReviewCount(cb) {
    if (cachedReviewCount !== null) {
      cb(cachedReviewCount)
      return
    }
    $.get('/cache/hodnoceni-obchodu/', function (html) {
      const $doc = $(html)
      const labelText = $doc.find('#ratingWrapper .rate-average-wrap .stars-label').first().text().trim()
      const digits = (labelText.match(/[\d\s]+/) || [''])[0].replace(/\s+/g, '').trim()
      if (digits) {
        cachedReviewCount = digits
        cb(digits)
      }
    })
  }

  function renderReviewSummary(countText) {
    const $summary = $('.review-summary')
    if (!$summary.length) return

    const $link = $summary.find('.review-summary__count a')
    if ($link.length) {
      // formát: "1234 recenzí"
      $link.text((countText || '—') + ' recenzí')
    }
  }

  function toggleReviewSummary() {
    const $summary = $('.review-summary')
    const isDesktop = window.matchMedia('(min-width: 991px)').matches

    if (isDesktop && !$summary.length) {
      const $el = $(`
        <aside class="review-summary">
          <div>
            <figure class="review-summary__badge">
              <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/heureka/heureka.svg" alt="" />
            </figure>
          </div>
          <div>
            <div class="review-summary__score">
              <h2 class="review-summary__percentage">99&nbsp;%</h2>
              <div class="review-summary__stars" aria-label="5 z 5 hvězdiček">
                <span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span>
              </div>
            </div>
            <div class="review-summary__count"><a href="/hodnoceni-obchodu/">… recenzí</a></div>
          </div>
        </aside>
      `).appendTo('.navigation-buttons')

      fetchReviewCount(function (count) {
        renderReviewSummary(count)
      })
    }

    if (!isDesktop && $summary.length) {
      $summary.remove()
    }
  }

  toggleReviewSummary()

  $(window).on('resize', function () {
    toggleReviewSummary()
  })
})


// typeDetail
// test
$(document).ready(function () {
  if ($('body').hasClass('type-detail') && $('body').hasClass('test')) {

    // stars
    $('<div class="stars"><span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span><span class="star star--filled">★</span></div>').prependTo('li[data-testid="tabRating"] a')

    // ratingBox
    $('<div class="rating-box"> <span class="rating-score">4.9</span><div class="rating-stars"><span class="star">⭐</span><span class="star">⭐</span><span class="star">⭐</span><span class="star">⭐</span><span class="star">⭐</span></div><a href="#" class="rating-count">430 hodnocení</a></div>').insertAfter('.p-detail-inner-header h1')

    // reviewsSection
    $(`<section class="reviews-section">

  <div class="reviews-summary">
  <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/heureka.svg" alt="" class="reviews-badge" />
    <span class="reviews-score">4,9</span>
    <div>
    <div class="reviews-stars">
      <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
      <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
      <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
      <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
      <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
    </div>
    <a href="#" class="reviews-count">755 hodnocení</a>
    </div>
  </div>

  <div class="reviews-list">
    <div class="review-card">
      <div class="review-header">
        <span class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg" alt="" /></span>
        <div class="review-stars">
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
        </div>
        <span class="review-date">23.8.2024</span>
      </div>
      <p class="review-text">Rychlé doručení</p>
    </div>

    <div class="review-card">
      <div class="review-header">
        <span class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg" alt="" /></span>
        <div class="review-stars">
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
        </div>
        <span class="review-date">23.8.2024</span>
      </div>
      <p class="review-text">Rychlé a kvalitní dodání, děkuji.</p>
    </div>

    <div class="review-card">
      <div class="review-header">
        <span class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg" alt="" /></span>
        <div class="review-stars">
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
        </div>
        <span class="review-date">23.8.2024</span>
      </div>
      <p class="review-text">Vzorná komunikace a rychlost dodání. Maximální spokojenost.</p>
    </div>

    <div class="review-card">
      <div class="review-header">
        <span class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg" alt="" /></span>
        <div class="review-stars">
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
          <span class="star"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" /></span>
        </div>
        <span class="review-date">23.8.2024</span>
      </div>
      <p class="review-text">+ vše bylo v pořádku - děkuji a doporučuji!</p>
    </div>
  </div>
</section>`).insertBefore('footer#footer')

    // reviewsSection
    $('<section class="reviews-section-product">\n' +
      '  <div class="reviews-summary">\n' +
      '    <div class="reviews-left">\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="reviews-center">\n' +
      '      </div>\n' +
      '\n' +
      '      <div class="rating-row">\n' +
      '      </div>\n' +
      '\n' +
      '      <div class="rating-row">\n' +
      '      </div>\n' +
      '\n' +
      '      <div class="rating-row">\n' +
      '      </div>\n' +
      '\n' +
      '      <div class="rating-row">\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="reviews-right">\n' +
      '  </div>\n' +
      '  </div>\n' +
      '\n' +
      '  <div class="reviews-list">\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Skvělá matrace, jsme spokojeni.</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Kateřina</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Všechno bezva</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Dominik</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Skvělá matrace, jsme spokojeni.</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Kateřina</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Všechno bezva</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Dominik</div>\n' +
      '    </div>\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Skvělá matrace, jsme spokojeni.</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Kateřina</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Všechno bezva</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Dominik</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Skvělá matrace, jsme spokojeni.</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Kateřina</div>\n' +
      '    </div>\n' +
      '\n' +
      '    <div class="review-card">\n' +
      '      <div class="review-header">\n' +
      '        <div class="stars"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/star.svg" alt="" loading="eager"></div>\n' +
      '        <span class="review-date">23.8.2024</span>\n' +
      '      </div>\n' +
      '      <p class="review-text">Všechno bezva</p>\n' +
      '      <div class="review-user"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/user.svg"> Dominik</div>\n' +
      '    </div>\n' +
      '  </div>\n' +
      '</section>\n').insertAfter('#description')

    var html = `
        <div class="callback-box">
  <div class="callback-content">
    <div class="agent-photo">
      <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/contact.svg" alt="contact" />
      <span class="online-status"><img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/on-line.svg" alt="on-line" /></span>
    </div>
    <div class="callback-form">
      <h3>Potřebujete poradit s výběrem?</h3>
      <p>Nechte nám na sebe číslo. Zavoláme vám a se vším poradíme</p>
      <div class="form-row">
        <input type="tel" placeholder="+420 123 456 789">
        <button>ZAVOLEJTE MI</button>
      </div>
    </div>
  </div>
  <div class="guarantee-box">
    <img src="https://www.vyspimese.cz/user/documents/upload/temp/detail-product/contact/badge.svg" alt="badge" />
    <div>
      <strong>U nás nakupujte bez starostí</strong>
      <p>Autorizovaný prodejce všech značek. 100% záruka. Záruční i pozáruční servis.</p>
    </div>
  </div>
</div>
        <ul class="benefit-product">
          <li><strong>Naše matrace se jen tak neproleží</strong>, minimum reklamací je toho důkazem</li>
          <li>Dokonale <strong>známe každou nabízenou matraci</strong></li>
          <li><strong>Osobně testujeme</strong> a kontrolujeme kvalitu dodavatelů</li>
          <li>Jsme <strong>přední prodejci</strong> nejznámějších výrobců</li>
          <li>Vyrobíme pro vás <a href="https://www.vyspimese.cz/form-matrace-na-miru/" target="_blank">matraci na míru</a></li>
        </ul>
      `
    $('.quality-banner').after(html)

  }
})


// typeDetail
// variantyMoreni
$(document).ready(function () {

  // Moření
  // START

  if (
    $('body').hasClass('type-detail')
  ) {

    // === Pomocná funkce ===
    const setSelectValueNative = (selectEl, value) => {
      const option = Array.from(selectEl.options).find(opt => opt.value === value)
      if (option) {
        option.selected = true
        selectEl.dispatchEvent(new Event('change', { bubbles: true }))
        selectEl.dispatchEvent(new Event('input', { bubbles: true }))
        if (typeof shoptet?.productDetail?.recalculatePrice === 'function') {
          shoptet.productDetail.recalculatePrice()
        }
        if (typeof shoptet?.surcharges?.countPrice === 'function') {
          shoptet.surcharges.countPrice()
        }
        console.log('[DEBUG] Native set + event dispatch:', value)
      } else {
        console.warn('[WARNING] Option not found for value:', value)
      }
    }

    const $masterWrapper = $('<div>', { class: 'master-radio-wrapper' })
    const $selectElements = $('select')

    if ($selectElements.length > 0) {
      const $availabilityLabel = $('.p-info-wrapper .availability-value')

      if ($availabilityLabel.length > 0) {
        const $variantButton = $('<div>', {
          class: 'choose-var',
          text: 'Přejít na výběr'
        }).on('click', () => {
          $masterWrapper.get(0).scrollIntoView({ behavior: 'smooth' })
        })

        $availabilityLabel.append($variantButton)
      }

      const $addToCart = $('.add-to-cart')

      const updateAvailableOptions = () => {
        $selectElements.each((index, select) => {
          if (index === 0) return
          const $select = $(select)
          $select.find('option').each((_, option) => {
            const $option = $(option)
            const $radio = $(`input[type="radio"][value="${$option.val()}"]`)
            const isUnavailable = $option.closest('optgroup').hasClass('unavailable-variants')

            if ($radio.length > 0) {
              $radio.prop('disabled', isUnavailable)
              $radio.closest('label').toggleClass('unavailable', isUnavailable)
            }
          })
        })
      }

      $selectElements.each((selectIndex, select) => {
        const $select = $(select)
        const $radioWrapper = $('<div>', { class: 'choose-parameters-wrap' })

        const labelName =
          $select.closest('tr').find('th').text().trim() ||
          $select.closest('.variant-list, .surcharge-list').find('span,strong').text().trim() ||
          ''

        if (labelName) {
          $radioWrapper.append($('<div>', {
            class: 'radio-wrapper-title',
            text: labelName
          }))

          const className = labelName
            .normalize?.('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .replace(/\s+/g, '-')

          if (className) {
            $radioWrapper.addClass(className)
          }
        }

        const $labelsContainer = $('<div>', { class: 'labels-container' })

        $select.find('option').each((optionIndex, option) => {
          const $option = $(option)
          if ($option.val() === '') return

          const radioId = `radio-${selectIndex}-${optionIndex}`
          const $radio = $('<input>', {
            type: 'radio',
            name: `radio-${$select.attr('name')}`,
            value: $option.val(),
            id: radioId
          }).on('change', () => {
            setSelectValueNative($select[0], $option.val())
            $labelsContainer.find('label').removeClass('active')
            $radio.closest('label').addClass('active')
            updateAvailableOptions()
          })

          if ($select.prop('required')) {
            $radio.prop('required', true)
          }

          $labelsContainer.append(
            $('<label>', { for: radioId })
              .append($radio)
              .append(` ${$option.text()}`)
          )
        })

        $radioWrapper.append($labelsContainer)
        $masterWrapper.append($radioWrapper)
      })

      if (!$('body').hasClass('template-07')) {
        $addToCart.before($masterWrapper)
      }

      updateAvailableOptions()

      const $form = $('#product-detail-form')

      const resetFormElements = () => {
        $form.find('select').prop('selectedIndex', 0)
        $form.find('input[type="radio"]').prop('checked', false)
        $form.find('.labels-container label').removeClass('active unavailable')
        $form.find('.error-message').remove()
      }

      $form.on('submit', (event) => {
        let formIsValid = true

        $selectElements.each((_, select) => {
          const $select = $(select)
          if ($select.prop('required')) {
            const $wrapper = $select.closest('.choose-parameters-wrap')
            const $selectedRadio = $wrapper.find(`input[name="radio-${$select.attr('name')}"]:checked`)

            if ($selectedRadio.length === 0) {
              formIsValid = false
              if ($wrapper.find('.error-message').length === 0) {
                $wrapper.append($('<div>', {
                  class: 'error-message',
                  text: 'Vyberte prosím požadovanou variantu.',
                  css: { color: 'red', marginTop: '5px' }
                }))
              }
              $wrapper.get(0).scrollIntoView({ behavior: 'smooth', block: 'center' })
            } else {
              $wrapper.find('.error-message').remove()
            }
          }
        })

        if (!formIsValid) {
          event.preventDefault()
        } else {
          setTimeout(resetFormElements, 1000)
        }
      })
    }

    const initLabelLimit = () => {
      const $wrapper = $('.choose-parameters-wrap.rozmer')
      const $labels = $wrapper.find('.labels-container label')

      if ($labels.length > 12 && !$wrapper.next('#toggle-more-btn').length) {
        $labels.slice(12).hide()

        const $btn = $('<button class="toggle-more-btn showMore" type="button">Další rozměry</button>')
        $wrapper.find('.labels-container').append($btn)

        $btn.on('click', function () {
          const isExpanded = $btn.data('expanded')

          if (isExpanded) {
            $labels.slice(12).hide()
            $btn.text('Další rozměry');
            $btn.addClass('showMore').removeClass('showLess');
          } else {
            $labels.show()
            $btn.text('Méně rozměrů');
            $btn.addClass('showLess').removeClass('showMore');
          }

          $btn.data('expanded', !isExpanded)
        })

        return true
      }

      return false
    }

    const interval = setInterval(() => {
      if (initLabelLimit()) {
        clearInterval(interval)
      }
    }, 300)

    // === Checkbox chování pro .chci-odvezt-starou-matraci ===
    const $checkboxWrapper = $('.choose-parameters-wrap.chci-odvezt-starou-matraci')

    if ($checkboxWrapper.length) {
      console.log('[DEBUG] Nalezen wrapper pro chci-odvezt-starou-matraci')

      const $radios = $checkboxWrapper.find('input[type="radio"]')
      let lastChecked = null

      $radios.on('mousedown', function () {
        this.wasChecked = this === lastChecked
      })

      $radios.on('click', function (e) {
        const $currentRadio = $(this)
        const $label = $currentRadio.closest('label')
        const $selectName = $currentRadio.attr('name')?.replace(/^radio-/, '')
        const $originalSelect = $(`select[name="${$selectName}"]`)

        if (!$originalSelect.length) {
          console.warn('[WARNING] Select nenalezen pro name:', $selectName)
          return
        }

        if ($currentRadio[0].wasChecked) {
          e.preventDefault()
          $currentRadio.prop('checked', false)
          $label.removeClass('active')
          lastChecked = null
          setSelectValueNative($originalSelect[0], '')
          console.log('[DEBUG] Checkbox zrušen')
        } else {
          $checkboxWrapper.find('label').removeClass('active')
          $label.addClass('active')
          lastChecked = $currentRadio[0]
          setSelectValueNative($originalSelect[0], $currentRadio.val())
          console.log('[DEBUG] Checkbox vybrán:', $currentRadio.val())
        }
      })
    }

    // $('.p-info-wrapper table.detail-parameters').hide()
    $('.p-info-wrapper table.detail-parameters').css({
      width: '0',
      height: '0',
      overflow: 'hidden',
      opacity: '0',
      visibility: 'hidden',
      padding: '0',
      margin: '0',
      border: '0'
    })

    // Moření
    // START

    // type-detail
    // live
    // bmb

    if (
      $('body').hasClass('type-detail') &&
      $('.product-top .p-info-wrapper a[href="/znacka/bmb/"]').length
    ) {


      $('<img src="/user/documents/upload/temp/moreni/8/dub-bardolino.jpg" alt="dub-bardolino" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub bardolino")')

      $('<img src="/user/documents/upload/temp/moreni/2/01-Bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("01 - Bílá")')
      $('<img src="/user/documents/upload/temp/moreni/2/07-Vosk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("07 - Vosk")')

      // 24 - Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '24 - Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/24-Olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/70-Belena.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("70 - Bělená")')
      $('<img src="/user/documents/upload/temp/moreni/2/71-Lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("71 - Lak")')
      $('<img src="/user/documents/upload/temp/moreni/2/74-Jablon.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("74 - Jabloň")')

      // 75 - Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '75 - Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/75-Mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/78-Bordo.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("78 - Bordó")')
      $('<img src="/user/documents/upload/temp/moreni/2/79-Tmavy-orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("79 - Tmavý ořech")')
      $('<img src="/user/documents/upload/temp/moreni/2/93-Kava.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("93 - Káva")')
      $('<img src="/user/documents/upload/temp/moreni/2/Antracit.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Antracit")')
      $('<img src="/user/documents/upload/temp/moreni/2/Cerna.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Černá")')
      $('<img src="/user/documents/upload/temp/moreni/2/Seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Šedá")')

      $('<img src="/user/documents/upload/temp/moreni/buk-masivni-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Grafit")')

      $('<img src="/user/documents/upload/temp/moreni/transparentni-lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní lak")')
      $('<img src="/user/documents/upload/temp/moreni/transparentni-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní olej")')
      $('<img src="/user/documents/upload/temp/moreni/chocolate.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Chocolate")')
      $('<img src="/user/documents/upload/temp/moreni/latte.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Latté")')
      $('<img src="/user/documents/upload/temp/moreni/nougat.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Nougat")')

      $('<img src="/user/documents/upload/temp/moreni/2/buk-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Wenge")')

      // B0
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B0'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B0.jpg" alt="" />')

      // B1
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B1.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/B6.jpg" alt="B6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B6")')
      $('<img src="/user/documents/upload/temp/moreni/2/B9.jpg" alt="B9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B9")')

      // B10
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B10'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B10.jpg" alt="" />')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B12.jpg" alt="" />')

      // připravujeme
      const pripravujemeKody = [
        'B2', 'B3', 'B4', 'B5', 'B71', 'B72', 'B8', 'přírodní lak',
        'B13', 'D1', 'D12', 'D72', 'D10'
      ]

      $('.choose-parameters-wrap.moreni .labels-container label').each(function () {
        const labelText = $(this).text().trim()
        if (pripravujemeKody.includes(labelText)) {
          $(this).prepend('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />')
        }
      })

      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-beleny.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bělený")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bílý")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej grafit")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej natur")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-origin.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej origin")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-palisandr.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej palisandr")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej wenge")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-patinovany.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub Patinovaný")')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-natur.jpg" alt="buk-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-tresen.jpg" alt="buk-tresen" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-orech.jpg" alt="buk-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - ořech")')

      // Buk - olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Buk - olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/4/buk-olse.jpg" alt="buk-olse" />')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-tabak.jpg" alt="buk-tabak" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - tabák")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-wenge.jpg" alt="buk-wenge" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - wenge")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-bila.jpg" alt="buk-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-gray.jpg" alt="buk-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - gray")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-natur.jpg" alt="dub-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-orech.jpg" alt="dub-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - ořech")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-bila.jpg" alt="dub-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-gray.jpg" alt="dub-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - gray")')

      $('<img src="/user/documents/upload/temp/moreni/5/beleny-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělený olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/bily-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bílý olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/natur-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Natur olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/palisandr-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Palisandr olej")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Patina")')

      $('<img src="/user/documents/upload/temp/moreni/6/alder.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Alder")')
      $('<img src="/user/documents/upload/temp/moreni/6/beige.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Beige")')
      $('<img src="/user/documents/upload/temp/moreni/6/beleni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělení")')
      $('<img src="/user/documents/upload/temp/moreni/6/cherry.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Cherry")')
      $('<img src="/user/documents/upload/temp/moreni/6/dark.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dark")')

      // Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/milk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Milk")')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/D0.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("D0")')

      // Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Ořech")')
      $('<img src="/user/documents/upload/temp/moreni/6/prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Přírodní")')
      $('<img src="/user/documents/upload/temp/moreni/6/tabak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tabák")')
      $('<img src="/user/documents/upload/temp/moreni/6/tobacco.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tobacco")')
      $('<img src="/user/documents/upload/temp/moreni/6/tresen.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/6/walnut.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Walnut")')
      $('<img src="/user/documents/upload/temp/moreni/6/white.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("White")')

      // olejNatur
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'olej natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olej-natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/olej-honey.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("olej honey")')

      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jeans")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Orange")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Red")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("bez povrchové úpravy")')

      $('<img src="/user/documents/upload/temp/dekor/dekor-akat.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Akát")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-buk.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Buk")')
      $('<img src="/user/documents/upload/temp/moreni/8/dub-bardolino.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub bardolino")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Šedá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-olse.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("olše")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-premiove-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Prémiově bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Natur")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.png" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-nebraska.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Nebraska")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-borovice-kodiak.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borovice Kodiak")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax bílý")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-tabakovy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax tabákový")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-aida.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Aida")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-sedy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub šedý")')
      $('<img src="/user/documents/upload/temp/dekor/2/min-borneo-antik.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borneo Antik")')

    }

    // type-detail
    // admin-logged
    // kolacia

    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/kolacia/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/moreni/2/01-Bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("01 - Bílá")')
      $('<img src="/user/documents/upload/temp/moreni/2/07-Vosk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("07 - Vosk")')

      // 24 - Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '24 - Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/24-Olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/70-Belena.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("70 - Bělená")')
      $('<img src="/user/documents/upload/temp/moreni/2/71-Lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("71 - Lak")')
      $('<img src="/user/documents/upload/temp/moreni/2/74-Jablon.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("74 - Jabloň")')

      // 75 - Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '75 - Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/75-Mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/78-Bordo.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("78 - Bordó")')
      $('<img src="/user/documents/upload/temp/moreni/2/79-Tmavy-orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("79 - Tmavý ořech")')
      $('<img src="/user/documents/upload/temp/moreni/2/93-Kava.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("93 - Káva")')
      $('<img src="/user/documents/upload/temp/moreni/2/Antracit.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Antracit")')
      $('<img src="/user/documents/upload/temp/moreni/2/Cerna.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Černá")')
      $('<img src="/user/documents/upload/temp/moreni/2/Seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Šedá")')

      $('<img src="/user/documents/upload/temp/moreni/buk-masivni-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Grafit")')

      $('<img src="/user/documents/upload/temp/moreni/transparentni-lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní lak")')
      $('<img src="/user/documents/upload/temp/moreni/transparentni-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní olej")')
      $('<img src="/user/documents/upload/temp/moreni/chocolate.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Chocolate")')
      $('<img src="/user/documents/upload/temp/moreni/latte.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Latté")')
      $('<img src="/user/documents/upload/temp/moreni/nougat.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Nougat")')

      $('<img src="/user/documents/upload/temp/moreni/2/buk-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Wenge")')

      // B0
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B0'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B0.jpg" alt="" />')

      // B1
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B1.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/B6.jpg" alt="B6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B6")')
      $('<img src="/user/documents/upload/temp/moreni/2/B9.jpg" alt="B9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B9")')

      // B10
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B10'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B10.jpg" alt="" />')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B12.jpg" alt="" />')

      // připravujeme
      const pripravujemeKody = [
        'B2', 'B3', 'B4', 'B5', 'B71', 'B72', 'B8', 'přírodní lak',
        'B13', 'D1', 'D12', 'D72', 'D10'
      ]

      $('.choose-parameters-wrap.moreni .labels-container label').each(function () {
        const labelText = $(this).text().trim()
        if (pripravujemeKody.includes(labelText)) {
          $(this).prepend('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />')
        }
      })

      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-beleny.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bělený")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bílý")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej grafit")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej natur")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-origin.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej origin")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-palisandr.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej palisandr")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej wenge")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-patinovany.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub Patinovaný")')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-natur.jpg" alt="buk-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-tresen.jpg" alt="buk-tresen" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-orech.jpg" alt="buk-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - ořech")')

      // Buk - olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Buk - olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/4/buk-olse.jpg" alt="buk-olse" />')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-tabak.jpg" alt="buk-tabak" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - tabák")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-wenge.jpg" alt="buk-wenge" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - wenge")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-bila.jpg" alt="buk-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-gray.jpg" alt="buk-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - gray")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-natur.jpg" alt="dub-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-orech.jpg" alt="dub-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - ořech")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-bila.jpg" alt="dub-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-gray.jpg" alt="dub-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - gray")')

      $('<img src="/user/documents/upload/temp/moreni/5/beleny-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělený olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/bily-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bílý olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/natur-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Natur olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/palisandr-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Palisandr olej")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Patina")')

      $('<img src="/user/documents/upload/temp/moreni/6/alder.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Alder")')
      $('<img src="/user/documents/upload/temp/moreni/6/beige.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Beige")')
      $('<img src="/user/documents/upload/temp/moreni/6/beleni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělení")')
      $('<img src="/user/documents/upload/temp/moreni/6/cherry.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Cherry")')
      $('<img src="/user/documents/upload/temp/moreni/6/dark.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dark")')

      // Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/milk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Milk")')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/D0.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("D0")')

      // Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Ořech")')
      $('<img src="/user/documents/upload/temp/moreni/6/prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Přírodní")')
      $('<img src="/user/documents/upload/temp/moreni/6/tabak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tabák")')
      $('<img src="/user/documents/upload/temp/moreni/6/tobacco.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tobacco")')
      $('<img src="/user/documents/upload/temp/moreni/6/tresen.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/6/walnut.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Walnut")')
      $('<img src="/user/documents/upload/temp/moreni/6/white.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("White")')

      // olejNatur
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'olej natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olej-natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/olej-honey.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("olej honey")')

      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jeans")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Orange")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Red")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("bez povrchové úpravy")')

      $('<img src="/user/documents/upload/temp/dekor/dekor-akat.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Akát")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-buk.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Buk")')
      $('<img src="/user/documents/upload/temp/moreni/8/dub-bardolino.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub bardolino")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Šedá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-olse.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("olše")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-premiove-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Prémiově bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Natur")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.png" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-nebraska.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Nebraska")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-borovice-kodiak.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borovice Kodiak")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax bílý")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-tabakovy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax tabákový")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-aida.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Aida")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-sedy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub šedý")')
      $('<img src="/user/documents/upload/temp/dekor/2/min-borneo-antik.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borneo Antik")')

    }


    // jelinek
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/jelinek/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/moreni/2/01-Bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("01 - Bílá")')
      $('<img src="/user/documents/upload/temp/moreni/2/07-Vosk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("07 - Vosk")')

      // 24 - Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '24 - Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/24-Olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/70-Belena.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("70 - Bělená")')
      $('<img src="/user/documents/upload/temp/moreni/2/71-Lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("71 - Lak")')
      $('<img src="/user/documents/upload/temp/moreni/2/74-Jablon.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("74 - Jabloň")')

      // 75 - Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === '75 - Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/75-Mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/78-Bordo.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("78 - Bordó")')
      $('<img src="/user/documents/upload/temp/moreni/2/79-Tmavy-orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("79 - Tmavý ořech")')
      $('<img src="/user/documents/upload/temp/moreni/2/93-Kava.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("93 - Káva")')
      $('<img src="/user/documents/upload/temp/moreni/2/Antracit.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Antracit")')
      $('<img src="/user/documents/upload/temp/moreni/2/Cerna.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Černá")')
      $('<img src="/user/documents/upload/temp/moreni/2/Seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Šedá")')

      $('<img src="/user/documents/upload/temp/moreni/buk-masivni-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Grafit")')

      $('<img src="/user/documents/upload/temp/moreni/transparentni-lak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní lak")')
      $('<img src="/user/documents/upload/temp/moreni/transparentni-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní olej")')
      $('<img src="/user/documents/upload/temp/moreni/chocolate.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Chocolate")')
      $('<img src="/user/documents/upload/temp/moreni/latte.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Latté")')
      $('<img src="/user/documents/upload/temp/moreni/nougat.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Nougat")')

      $('<img src="/user/documents/upload/temp/moreni/2/buk-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Wenge")')

      // B0
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B0'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B0.jpg" alt="" />')

      // B1
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B1.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/B6.jpg" alt="B6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B6")')
      $('<img src="/user/documents/upload/temp/moreni/2/B9.jpg" alt="B9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("B9")')

      // B10
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B10'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B10.jpg" alt="" />')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'B12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/2/B12.jpg" alt="" />')

      // připravujeme
      const pripravujemeKody = [
        'B2', 'B3', 'B4', 'B5', 'B71', 'B72', 'B8', 'přírodní lak',
        'B13', 'D1', 'D12', 'D72', 'D10'
      ]

      $('.choose-parameters-wrap.moreni .labels-container label').each(function () {
        const labelText = $(this).text().trim()
        if (pripravujemeKody.includes(labelText)) {
          $(this).prepend('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />')
        }
      })

      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-beleny.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bělený")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej bílý")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-grafit.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej grafit")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej natur")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-origin.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej origin")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-palisandr.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej palisandr")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-olej-wenge.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub olej wenge")')
      $('<img src="/user/documents/upload/temp/moreni/3/dub-patinovany.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub Patinovaný")')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-natur.jpg" alt="buk-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-tresen.jpg" alt="buk-tresen" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-orech.jpg" alt="buk-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - ořech")')

      // Buk - olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Buk - olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/4/buk-olse.jpg" alt="buk-olse" />')

      $('<img src="/user/documents/upload/temp/moreni/4/buk-tabak.jpg" alt="buk-tabak" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - tabák")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-wenge.jpg" alt="buk-wenge" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - wenge")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-bila.jpg" alt="buk-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/buk-gray.jpg" alt="buk-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - gray")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-natur.jpg" alt="dub-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - natur")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-orech.jpg" alt="dub-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - ořech")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-bila.jpg" alt="dub-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/4/dub-gray.jpg" alt="dub-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - gray")')

      $('<img src="/user/documents/upload/temp/moreni/5/beleny-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělený olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/bily-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bílý olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/natur-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Natur olej")')
      $('<img src="/user/documents/upload/temp/moreni/5/palisandr-olej.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Palisandr olej")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Patina")')

      $('<img src="/user/documents/upload/temp/moreni/6/alder.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Alder")')
      $('<img src="/user/documents/upload/temp/moreni/6/beige.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Beige")')
      $('<img src="/user/documents/upload/temp/moreni/6/beleni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bělení")')
      $('<img src="/user/documents/upload/temp/moreni/6/cherry.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Cherry")')
      $('<img src="/user/documents/upload/temp/moreni/6/dark.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dark")')

      // Mahagon
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Mahagon'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/mahagon.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/milk.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Milk")')

      // B12
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/2/D0.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("D0")')

      // Olše
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Olše'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olse.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/orech.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Ořech")')
      $('<img src="/user/documents/upload/temp/moreni/6/prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Přírodní")')
      $('<img src="/user/documents/upload/temp/moreni/6/tabak.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tabák")')
      $('<img src="/user/documents/upload/temp/moreni/6/tobacco.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tobacco")')
      $('<img src="/user/documents/upload/temp/moreni/6/tresen.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/6/walnut.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Walnut")')
      $('<img src="/user/documents/upload/temp/moreni/6/white.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("White")')

      // olejNatur
      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'olej natur'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/6/olej-natur.jpg" alt="" />')

      $('<img src="/user/documents/upload/temp/moreni/6/olej-honey.jpg" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("olej honey")')

      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jeans")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Orange")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Red")')
      $('<img src="/user/documents/upload/temp/moreni/2/pripravujeme.png" alt="" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("bez povrchové úpravy")')

      $('<img src="/user/documents/upload/temp/dekor/dekor-akat.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Akát")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-buk.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Buk")')
      $('<img src="/user/documents/upload/temp/moreni/8/dub-bardolino.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub bardolino")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-seda.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Šedá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-olse.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("olše")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-premiove-bila.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Prémiově bílá")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-natur.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Natur")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.png" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-nebraska.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Nebraska")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-borovice-kodiak.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borovice Kodiak")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-bily.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax bílý")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-prirodni.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax přírodní")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-tabakovy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax tabákový")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-orech-aida.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Ořech Aida")')
      $('<img src="/user/documents/upload/temp/dekor/dekor-dub-halifax-sedy.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub šedý")')
      $('<img src="/user/documents/upload/temp/dekor/2/min-borneo-antik.jpg" alt="" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Borneo Antik")')

    }

    // brand
    // kolacia
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/kolacia/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/olej/olej-c-1.jpg" alt="olej-c-1" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 1")')
      $('<img src="/user/documents/upload/temp/olej/olej-c-2.jpg" alt="olej-c-2" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 2")')
      $('<img src="/user/documents/upload/temp/olej/olej-c-3.jpg" alt="olej-c-3" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 3")')
      $('<img src="/user/documents/upload/temp/olej/olej-c-5.jpg" alt="olej-c-5" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 5")')
      $('<img src="/user/documents/upload/temp/olej/olej-c-6.jpg" alt="olej-c-6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 6")')
      $('<img src="/user/documents/upload/temp/olej/olej-c-7.jpg" alt="olej-c-7" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Olej č. 7")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-10.jpg" alt="lak-c-10" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 10")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-11.jpg" alt="lak-c-11" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 11")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-15.jpg" alt="lak-c-15" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 15")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-20.jpg" alt="lak-c-20" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 20")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-40.png" alt="lak-c-40" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 40")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-50.jpg" alt="lak-c-50" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 50")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-60.jpg" alt="lak-c-60" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 60")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-70.png" alt="lak-c-70" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 70")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-120.png" alt="lak-c-120" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 120")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-130.png" alt="lak-c-130" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 130")')
      $('<img src="/user/documents/upload/temp/olej/lak-c-30.jpg" alt="lak-c-30" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Lak č. 30")')
    }


    // brand
    // stach
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/ahorn/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/ahorn/chocolate.jpg" alt="chocolate" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Chocolate")')
      $('<img src="/user/documents/upload/temp/ahorn/lak-transparent.jpg" alt="lak-transparent" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains(" Transparentní lak")')
      $('<img src="/user/documents/upload/temp/ahorn/latte.jpg" alt="latte" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Latté")')
      $('<img src="/user/documents/upload/temp/ahorn/nougat.jpg" alt="nougat" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Nougat")')
      $('<img src="/user/documents/upload/temp/ahorn/olej-transparent.jpg" alt="olej-transparent" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Transparentní olej")')
      $('<img src="/user/documents/upload/temp/ahorn/platinum.jpg" alt="platinum" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - natur")')
      $('<img src="/user/documents/upload/temp/ahorn/2/16-pink.jpg" alt="16-pink" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("16 Pink")')
      $('<img src="/user/documents/upload/temp/ahorn/2/17-taupe.jpg" alt="17-taupe" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("17 taupe")')
      $('<img src="/user/documents/upload/temp/ahorn/2/13-charcoal.jpg" alt="13-charcoal" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("23 Charcoal")')
      $('<img src="/user/documents/upload/temp/ahorn/2/14-blue.jpg" alt="14-blue" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("14 Blue")')
      $('<img src="/user/documents/upload/temp/ahorn/2/13-aqua.jpg" alt="13-aqua" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("13 Aqua")')
      $('<img src="/user/documents/upload/temp/ahorn/2/6-chestnut.jpg" alt="6-chestnut" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("6 Chestnut")')
      $('<img src="/user/documents/upload/temp/ahorn/2/1-cream.jpg" alt="1-cream" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("1 Cream")')
      $('<img src="/user/documents/upload/temp/ahorn/2/10-bottle-green.jpg" alt="10-bottle-green" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("10 Bottle green")')
      $('<img src="/user/documents/upload/temp/ahorn/2/black-ink.jpg" alt="black-ink" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Black ink")')
      $('<img src="/user/documents/upload/temp/ahorn/2/steel-gray.jpg" alt="steel-gray" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Steel gray")')
      $('<img src="/user/documents/upload/temp/ahorn/2/lunar-rock.jpg" alt="lunar-rock" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Lunar rock")')
      $('<img src="/user/documents/upload/temp/ahorn/2/simple-taupe.jpg" alt="simple-taupe" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Simple taupe")')
      $('<img src="/user/documents/upload/temp/ahorn/2/rifle-green.jpg" alt="rifle-green" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Rifle green")')
      $('<img src="/user/documents/upload/temp/ahorn/2/pine-grove.jpg" alt="pine-grove" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Pine grove")')
      $('<img src="/user/documents/upload/temp/ahorn/2/01-slonova-kost.jpg" alt="01-slonova-kost" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("01 Slonová kost")')
      $('<img src="/user/documents/upload/temp/ahorn/2/04-bezova.jpg" alt="04-bezova" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains(" 04 Béžová")')
      $('<img src="/user/documents/upload/temp/ahorn/2/14-sedo-bezova.jpg" alt="14-sedo-bezova" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains(" 14 Šedo - béžová")')
      $('<img src="/user/documents/upload/temp/ahorn/2/26-seda.jpg" alt="26-seda" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("26 Šedá")')
      $('<img src="/user/documents/upload/temp/ahorn/2/37-tm-modra.jpg" alt="37-tm-modra" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("37 Tm. modrá")')
      $('<img src="/user/documents/upload/temp/ahorn/2/56-tm-seda.jpg" alt="56-tm-seda" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("56 Tm. šedá")')

      $('<img src="/user/documents/upload/temp/ahorn/3/steel-gray.jpg" alt="steel-gray" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Steel gray")')
      $('<img src="/user/documents/upload/temp/ahorn/3/lunar-rock.jpg" alt="lunar-rock" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Lunar rock")')
      $('<img src="/user/documents/upload/temp/ahorn/3/simple-taupe.jpg" alt="simple-taupe" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Simple taupe")')
      $('<img src="/user/documents/upload/temp/ahorn/3/rifle-green.jpg" alt="rifle-green" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Rifle green")')
      $('<img src="/user/documents/upload/temp/ahorn/3/pine-grove.jpg" alt="pine-grove" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Pine grove")')
      $('<img src="/user/documents/upload/temp/ahorn/3/black-ink.jpg" alt="black-ink" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Black ink")')

      $('<img src="/user/documents/upload/temp/ahorn/4/1-cream.jpg" alt="1-cream" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("1 Cream")')
      $('<img src="/user/documents/upload/temp/ahorn/4/6-chestnut.jpg" alt="6-chestnut" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("6 Chestnut")')
      $('<img src="/user/documents/upload/temp/ahorn/4/13-aqua.jpg" alt="13-aqua" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("13 Aqua")')
      $('<img src="/user/documents/upload/temp/ahorn/4/14-blue.jpg" alt="14-blue" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("14 Blue")')
      $('<img src="/user/documents/upload/temp/ahorn/4/16-pink.jpg" alt="16-pink" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("16 Pink")')
      $('<img src="/user/documents/upload/temp/ahorn/4/17-taupe.jpg" alt="17-taupe" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("17 taupe")')
      $('<img src="/user/documents/upload/temp/ahorn/4/10-bottle-green.jpg" alt="10-bottle-green" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("10 Bottle green")')
      $('<img src="/user/documents/upload/temp/ahorn/4/13-charcoal.jpg" alt="13-charcoal" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("13 Charcoal")')

      $('<img src="/user/documents/upload/temp/ahorn/5/01-slonova-kost.jpg" alt="01-slonova-kost" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("01 Slonová kost")')
      $('<img src="/user/documents/upload/temp/ahorn/5/04-bezova.jpg" alt="04-bezova" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("04 Béžová")')
      $('<img src="/user/documents/upload/temp/ahorn/5/14-sedo-bezova.jpg" alt="14-sedo-bezova" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("14 Šedo - béžová")')
      $('<img src="/user/documents/upload/temp/ahorn/5/26-seda.jpg" alt="26-seda" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("26 Šedá")')
      $('<img src="/user/documents/upload/temp/ahorn/5/37-tm-modra.jpg" alt="37-tm-modra" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("37 Tm. modrá")')
      $('<img src="/user/documents/upload/temp/ahorn/5/56-tm-seda.jpg" alt="56-tm-seda" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("56 Tm. šedá")')

    }


    if (
      $('body').hasClass('type-detail') &&
      $('.product-top .p-info-wrapper a[href="/znacka/lermo/"]').length
    ) {
      $('<img src="/user/documents/upload/temp/lermo/buk-svetly.jpg" alt="buk-svetly" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Buk světlý")')
      $('<img src="/user/documents/upload/temp/lermo/dub-sonoma.jpg" alt="dub-sonoma" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Sonoma")')
      $('<img src="/user/documents/upload/temp/lermo/sherwood.jpg" alt="sherwood" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Sherwood")')
      $('<img src="/user/documents/upload/temp/lermo/bila-gravir.jpg" alt="bila-gravir" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Bílá gravír")')
      $('<img src="/user/documents/upload/temp/lermo/dub-zlaty.jpg" alt="dub-zlaty" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub zlatý")')
      $('<img src="/user/documents/upload/temp/lermo/buk-iconic.jpg" alt="buk-iconic" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("buk iconic")')

      $('.choose-parameters-wrap.dekor .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'ořech'
        })
        .prepend('<img src="/user/documents/upload/temp/lermo/orech.jpg" alt="orech" />')

      $('<img src="/user/documents/upload/temp/lermo/antracit.gif" alt="antracit" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("antracit")')
      $('<img src="/user/documents/upload/temp/lermo/dub-ebro.jpg" alt="dub-ebro" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub ebro")')
      $('<img src="/user/documents/upload/temp/lermo/dub-grande.jpg" alt="dub-grande" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub grande")')
      $('<img src="/user/documents/upload/temp/lermo/dub-imatra.jpg" alt="dub-imatra" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub imatra")')
      $('<img src="/user/documents/upload/temp/lermo/dub-molveno.jpg" alt="dub-molveno" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub molveno")')
      $('<img src="/user/documents/upload/temp/lermo/dub-saint-tropez.jpg" alt="dub-saint-tropez" />')
        .prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("dub saint tropez")')

      $('.choose-parameters-wrap.dekor .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'ořech nord'
        })
        .prepend('<img src="/user/documents/upload/temp/lermo/orech-nord.jpg" alt="orech-nord" />')
    }


    if (
      // $('body').hasClass('admin-logged') &&
      $('body').hasClass('type-detail') &&
      $('.product-top .p-info-wrapper a[href="/znacka/purtex/"]').length
    ) {
      $('<img src="/user/documents/upload/temp/purtex/tresen.jpg" alt="tresen" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Třešeň")')

      $('<img src="/user/documents/upload/temp/purtex/tabak.jpg" alt="tabak" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Tabák")')

      $('<img src="/user/documents/upload/temp/purtex/orech.jpg" alt="orech" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Ořech")')

      $('<img src="/user/documents/upload/temp/purtex/purtex-bila.png" alt="purtex-bila" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Bílá")')

      $('<img src="/user/documents/upload/temp/purtex/seda.jpg" alt="seda" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Šedá")')

      $('<img src="/user/documents/upload/temp/purtex/cerna.jpg" alt="cerna" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Černá")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'buk lakovaný'
        })
        .prepend('<img src="/user/documents/upload/temp/purtex/buk-lakovany.jpg" alt="buk-lakovany" />')

      $('<img src="/user/documents/upload/temp/purtex/palisandr.jpg" alt="palisandr" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("palisandr")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'dub'
        })
        .prepend('<img src="/user/documents/upload/temp/purtex/dub.jpg" alt="dub" />')

      $('<img src="/user/documents/upload/temp/purtex/dub-beleny.jpg" alt="dub-beleny" />')
        .prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("dub bělený")')
    }


    // brand
    // stach
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/stach/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/moreni/7/buk-natur.jpg" alt="buk-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - natur")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-tresen.jpg" alt="buk-tresen" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - třešeň")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-orech.jpg" alt="buk-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - ořech")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-olse.jpg" alt="buk-olse" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - olše")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-tabak.jpg" alt="buk-tabak" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - tabák")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-wenge.jpg" alt="buk-wenge" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - wenge")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-bila.jpg" alt="buk-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/7/buk-gray.jpg" alt="buk-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk - gray")')
      $('<img src="/user/documents/upload/temp/moreni/7/dub-natur.jpg" alt="dub-natur" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - natur")')
      $('<img src="/user/documents/upload/temp/moreni/7/dub-orech.jpg" alt="dub-orech" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - ořech")')
      $('<img src="/user/documents/upload/temp/moreni/7/dub-bila.jpg" alt="dub-bila" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - bílá")')
      $('<img src="/user/documents/upload/temp/moreni/7/dub-gray.jpg" alt="dub-gray" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub - gray")')

    }


    // brand
    // stach
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/ahorn/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/imitace/dub-bardolino-prirodni.jpg" alt="dub-bardolino-prirodni" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub bardolino přírodní")')
      $('<img src="/user/documents/upload/temp/imitace/dub-halifax-bily.jpg" alt="dub-halifax-bily" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax bílý")')
      $('<img src="/user/documents/upload/temp/imitace/dub-halifax-prirodni.jpg" alt="dub-halifax-prirodni" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax přírodní")')
      $('<img src="/user/documents/upload/temp/imitace/dub-halifax-tabakovy.jpg" alt="dub-halifax-tabakovy" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub Halifax tabákový")')
      $('<img src="/user/documents/upload/temp/imitace/dub-kansas-hnedy.jpg" alt="dub-kansas-hnedy" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Dub kansas hnědý")')
      $('<img src="/user/documents/upload/temp/imitace/eukalyptus-tmave-hnedy.jpg" alt="eukalyptus-tmave-hnedy" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Eukalyptus tmavě hnědý")')
      $('<img src="/user/documents/upload/temp/imitace/premiove-bila.jpg" alt="premiove-bila" />').prependTo('.choose-parameters-wrap.dekor .labels-container label:contains("Prémiové bílá")')

    }


    // gwdesign
    // stach
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/gwdesign/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J72.jpg" alt="Jasan-J72" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jasan-J72")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J6.jpg" alt="Jasan-J6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jasan-J6")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J9.jpg" alt="Jasan-J9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jasan-J9")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Jasan-J12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J12.jpg" alt="Jasan-J12" />')

      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J34.jpg" alt="Jasan-J34" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jasan-J34")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Jasan-J1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J1.jpg" alt="Jasan-J1" />')

      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Jasan-J0.jpg" alt="Jasan-J0" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Jasan-J0")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-BO.jpg" alt="Buk-BO" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk-B0")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B72.jpg" alt="Buk-B72" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk-B72")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B6.jpg" alt="Buk-B6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk-B6")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B9.jpg" alt="Buk-B9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk-B9")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Buk-B12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B12.jpg" alt="Buk-B12" />')

      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B34.jpg" alt="Buk-B34" />\n').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Buk-B34")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Buk-B1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Buk-B1.jpg" alt="Buk-B1" />')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Dub-D1'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D1.jpg" alt="Dub-D1" />')

      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D0.jpg" alt="Dub-D0" />\n').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub-D0")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D9.jpg" alt="Dub-D9" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub-D9")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D34.jpg" alt="Dub-D34" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub-D34")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D6.jpg" alt="Dub-D6" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub-D6")')
      $('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D72.jpg" alt="Dub-D72" />').prependTo('.choose-parameters-wrap.moreni .labels-container label:contains("Dub-D72")')

      $('.choose-parameters-wrap.moreni .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Dub-D12'
        })
        .prepend('<img src="/user/documents/upload/temp/moreni/gwdesign/Dub-D12.jpg" alt="Dub-D12" />')

    }


    // gwdesign
    // stach
    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/iron-art/"]').length
      )
    ) {

      $('<img src="/user/documents/upload/temp/moreni/iron-art/5-cerna.jpg" alt="5-cerna" />').prependTo('.choose-parameters-wrap.barva-kovu .labels-container label:contains("5 černá")')
      $('<img src="/user/documents/upload/temp/moreni/iron-art/8-kremova.jpg" alt="8-kremova" />').prependTo('.choose-parameters-wrap.barva-kovu .labels-container label:contains("8 krémová")')
      $('<img src="/user/documents/upload/temp/moreni/iron-art/9-bila.jpg" alt="9-bila" />').prependTo('.choose-parameters-wrap.barva-kovu .labels-container label:contains("9 bílá")')
      $('<img src="/user/documents/upload/temp/moreni/iron-art/10-kovarska-seda.jpg" alt="10-kovarska-seda" />').prependTo('.choose-parameters-wrap.barva-kovu .labels-container label:contains("10 kovářská šedá")')

    }

    if (
      $('body').hasClass('type-detail') &&
      (
        $('.product-top .p-info-wrapper a[href="/znacka/vyspimese-cz/"]').length || $('.breadcrumbs [itemprop="name"]').toArray().some(el => {
      return $(el).text().trim() === 'Postele'
    })
      )
    ) {

      $('<img src="/user/documents/upload/temp/potahova-latka/alfa16.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("ALFA16")')
      $('<img src="/user/documents/upload/temp/potahova-latka/alfa17.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("ALFA17")')
      $('<img src="/user/documents/upload/temp/potahova-latka/alfa18.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("ALFA18")')
      $('<img src="/user/documents/upload/temp/potahova-latka/alfa80.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("ALFA80")')
      $('<img src="/user/documents/upload/temp/potahova-latka/aragon14.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Aragon14")')
      $('<img src="/user/documents/upload/temp/potahova-latka/aragon20.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Aragon20")')
      $('<img src="/user/documents/upload/temp/potahova-latka/aragon75.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Aragon75")')
      $('<img src="/user/documents/upload/temp/potahova-latka/aragon90.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Aragon90")')
      $('<img src="/user/documents/upload/temp/potahova-latka/aragon93.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Aragon93")')
      $('<img src="/user/documents/upload/temp/potahova-latka/bery26.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Bery26")')
      $('<img src="/user/documents/upload/temp/potahova-latka/bery28.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Bery28")')
      $('<img src="/user/documents/upload/temp/potahova-latka/letto11.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Letto11")')
      $('<img src="/user/documents/upload/temp/potahova-latka/letto85.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Letto85")')
      $('<img src="/user/documents/upload/temp/potahova-latka/letto88.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Letto88")')
      $('<img src="/user/documents/upload/temp/potahova-latka/solar11.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Solar11")')
      $('<img src="/user/documents/upload/temp/potahova-latka/solar16.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Solar16")')
      $('<img src="/user/documents/upload/temp/potahova-latka/solar96.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Solar96")')
      $('<img src="/user/documents/upload/temp/potahova-latka/voss15.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Voss15")')
      $('<img src="/user/documents/upload/temp/potahova-latka/voss28.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Voss28")')
      $('<img src="/user/documents/upload/temp/potahova-latka/voss38.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Voss38")')
      $('<img src="/user/documents/upload/temp/potahova-latka/voss7.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Voss7")')
      
      
      $('<img src="/user/documents/upload/temp/potahova-latka/alfa11.jpg" alt="" />').prependTo('.choose-parameters-wrap.potahova-latka .labels-container label:contains("Alfa11")')





      $('.choose-parameters-wrap.potahova-latka .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'ALFA8'
        })
        .prepend('<img src="/user/documents/upload/temp/potahova-latka/alfa8.jpg" alt="" />')

      $('.choose-parameters-wrap.potahova-latka .labels-container label')
        .filter(function () {
          return $(this).text().trim() === 'Solar80'
        })
        .prepend('<img src="/user/documents/upload/temp/potahova-latka/solar80.jpg" alt="" />')
    }
  }

  // END
  // Moření

  // Atyp
  // START


  ; (function waitForJqueryAndRun() {
    if (typeof window.jQuery === 'undefined') {
      setTimeout(waitForJqueryAndRun, 100)
      return
    }

    $(function () {
      var allowedBrands = ['Dřevočal', 'MPO Matrace', 'Materasso', 'Magniflex', 'Moravia Comfort', 'Řešeto']
      var STORAGE_PREFIX = 'custom-mattress:' // historické – ponecháno pro kompatibilitu klíčů
      var ATYP_STORE_ID = 'atyp-store'
      var COOKIE_NAME = 'custom-mattress-entries'
      var COOKIE_MAX_AGE_DAYS = 14
      var COOKIE_MAX_ITEMS = 30

      // Session pro oddělení jedné návštěvy/košíku
      var SESSION_COOKIE_NAME = 'custom-mattress-session'

      // Texty alertů (ponechány kvůli kompatibilitě – aktuálně se ignorují)
      var ATYP_ALERT_BOTH_TOO_BIG =
        'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_WIDTH_TOO_BIG =
        'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_HEIGHT_TOO_BIG =
        'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_DEFAULT =
        'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'

      function log() {
        try {
          console.log.apply(console, arguments)
        } catch (e) { }
      }

      function warn() {
        try {
          console.warn.apply(console, arguments)
        } catch (e) { }
      }

      function err() {
        try {
          console.error.apply(console, arguments)
        } catch (e) { }
      }

      function clean(s) {
        return String(s || '')
          .replace(/\s+/g, ' ')
          .trim()
      }

      function nowTs() {
        return Date.now()
      }

      function slug(s) {
        s = String(s || '')
        try {
          s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
        } catch (e) { }
        return s
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '')
      }

      function makeKey(productName, w, h) {
        return STORAGE_PREFIX + slug(productName) + '--' + w + 'x' + h
      }

      function parseSizeAnywhere(txt) {
        var m = String(txt || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*(?:cm)?/i)
        return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : null
      }

      function looseMatch(a, b) {
        var A = slug(a),
          B = slug(b)
        if (!A || !B) return false
        if (A === B) return true

        function stripDims(t) {
          return t
            .replace(/-\d+(?:-\d+)?-?cm\b/g, '')
            .replace(/-\d+-?cm\b/g, '')
            .replace(/-\d{2,3}\b/g, '')
        }

        var As = stripDims(A),
          Bs = stripDims(B)
        return As === Bs || As.indexOf(Bs) > -1 || Bs.indexOf(As) > -1 || A.indexOf(B) > -1 || B.indexOf(A) > -1
      }

      function readCookie(name) {
        try {
          var parts = document.cookie.split('; ')
          for (var i = 0; i < parts.length; i++) {
            var p = parts[i]
            if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.substring(name.length + 1))
          }
        } catch (e) { }
        return ''
      }

      function writeCookie(name, value, days) {
        try {
          var d = new Date()
          d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
          var expires = 'expires=' + d.toUTCString()
          document.cookie = name + '=' + encodeURIComponent(value) + '; ' + expires + '; path=/; SameSite=Lax'
        } catch (e) {
          warn('[ATYP] writeCookie fail', e)
        }
      }

      function deleteCookie(name) {
        try {
          document.cookie = name + '=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax'
        } catch (e) {
          warn('[ATYP] deleteCookie fail', e)
        }
      }

      function ensureSessionId() {
        var sid = readCookie(SESSION_COOKIE_NAME)
        if (!sid) {
          sid = Math.random().toString(36).slice(2) + Date.now().toString(36)
          writeCookie(SESSION_COOKIE_NAME, sid, COOKIE_MAX_AGE_DAYS)
        }
        return sid
      }

      var SESSION_ID = ensureSessionId()

      function loadEntriesFromCookie() {
        try {
          var raw = readCookie(COOKIE_NAME)
          if (!raw) return []
          var arr = JSON.parse(raw)
          if (!Array.isArray(arr)) return []
          arr.sort(function (a, b) {
            return (b.savedAt || 0) - (a.savedAt || 0)
          })
          return arr
        } catch (e) {
          warn('[ATYP] loadEntriesFromCookie parse fail', e)
          return []
        }
      }

      function saveEntriesToCookie(arr) {
        try {
          var pruned = (arr || []).slice(0, COOKIE_MAX_ITEMS)
          writeCookie(COOKIE_NAME, JSON.stringify(pruned), COOKIE_MAX_AGE_DAYS)
        } catch (e) {
          warn('[ATYP] saveEntriesToCookie fail', e)
        }
      }

      function upsertEntryToCookie(entry) {
        if (!entry || !entry.cleanProductName || !entry.width || !entry.height) return
        var list = loadEntriesFromCookie()
        var keySlug = slug(entry.cleanProductName)

        // doplň sessionId do entry
        entry.sessionId = SESSION_ID

        // odstranění naprostých duplikátů v rámci stejné session (produkt+rozměr+sku+bind)
        list = list.filter(function (it) {
          var sameProd = it.productSlug === keySlug || looseMatch(it.cleanProductName, entry.cleanProductName)
          var sameDim = it.width === entry.width && it.height === entry.height
          var sameSku = !entry.sku || !it.sku ? true : String(it.sku).trim() === String(entry.sku).trim()
          var sameBind = (it.bindW || null) === (entry.bindW || null) && (it.bindH || null) === (entry.bindH || null)
          var sameSession = it.sessionId === entry.sessionId
          return !(sameProd && sameDim && sameSku && sameBind && sameSession)
        })

        // NEmažeme starší atypy stejného produktu – umožníme víc různých rozměrů u jednoho produktu

        var toSave = $.extend({}, entry, { savedAt: entry.savedAt || nowTs(), productSlug: keySlug })
        list.unshift(toSave)
        saveEntriesToCookie(list)
        log('[ATYP] upsertEntryToCookie (session-scoped):', toSave, '(list size:', list.length, ')')
      }

      // smaže pro daný produkt v aktuální session všechny záznamy, které nejsou z add-to-cart
      function pruneNonCartEntriesForProduct(productSlugKey) {
        try {
          var list = loadEntriesFromCookie()
          var filtered = []
          for (var i = 0; i < list.length; i++) {
            var it = list[i]
            if (!it) continue
            if (it.sessionId !== SESSION_ID) {
              filtered.push(it)
              continue
            }
            var pSlug = it.productSlug || slug(clean(it.cleanProductName || ''))
            if (pSlug !== productSlugKey) {
              filtered.push(it)
              continue
            }
            // stejný produkt + tato session → necháme jen add-to-cart
            if (it.source === 'add-to-cart') filtered.push(it)
          }
          saveEntriesToCookie(filtered)
          log('[ATYP] pruneNonCartEntriesForProduct:', productSlugKey, 'from', list.length, 'to', filtered.length)
        } catch (e) {
          warn('[ATYP] pruneNonCartEntriesForProduct fail', e)
        }
      }

      function ensureDomStore() {
        var $el = $('#' + ATYP_STORE_ID)
        if (!$el.length) {
          $el = $('<div id="' + ATYP_STORE_ID + '" style="display:none" aria-hidden="true"></div>')
          $('body').append($el)
        }
        return $el
      }

      function destroyDomStore() {
        $('#' + ATYP_STORE_ID).remove()
      }

      window.addEventListener('pagehide', destroyDomStore)
      window.addEventListener('beforeunload', destroyDomStore)

      function domUpsertAtypEntry(entry) {
        var $root = ensureDomStore()
        var key = makeKey(entry.cleanProductName, entry.width, entry.height)
        var $old = $root.find('.atyp-item[data-key="' + key + '"]')
        var $node = $(
          '<div class="atyp-item" ' +
          ' data-key="' +
          key +
          '" ' +
          ' data-product="' +
          (entry.cleanProductName || '') +
          '" ' +
          ' data-product-slug="' +
          (entry.productSlug || '') +
          '" ' +
          ' data-width="' +
          entry.width +
          '" ' +
          ' data-height="' +
          entry.height +
          '" ' +
          ' data-bindw="' +
          (entry.bindW || '') +
          '" ' +
          ' data-bindh="' +
          (entry.bindH || '') +
          '" ' +
          ' data-sku="' +
          (entry.sku || '') +
          '" ' +
          ' data-source="' +
          (entry.source || '') +
          '" ' +
          ' data-savedat="' +
          (entry.savedAt || nowTs()) +
          '" ' +
          ' data-session="' +
          (entry.sessionId || '') +
          '"></div>'
        )
        if ($old.length) {
          $old.replaceWith($node)
        } else {
          $root.append($node)
        }
      }

      function readDomStore() {
        var $root = $('#' + ATYP_STORE_ID)
        if (!$root.length) return []
        var out = []
        $root.find('.atyp-item').each(function () {
          var $i = $(this)
          var width = parseInt($i.attr('data-width'), 10)
          var height = parseInt($i.attr('data-height'), 10)
          if (!width || !height) return
          var bindW = parseInt($i.attr('data-bindw'), 10)
          var bindH = parseInt($i.attr('data-bindh'), 10)
          out.push({
            cleanProductName: $i.attr('data-product') || '',
            productSlug: $i.attr('data-product-slug') || '',
            width: width,
            height: height,
            bindW: isNaN(bindW) ? null : bindW,
            bindH: isNaN(bindH) ? null : bindH,
            sku: $i.attr('data-sku') || '',
            source: $i.attr('data-source') || '',
            sessionId: $i.attr('data-session') || '',
            savedAt: parseInt($i.attr('data-savedat'), 10) || 0,
          })
        })
        out.sort(function (a, b) {
          return (b.savedAt || 0) - (a.savedAt || 0)
        })
        return out
      }

      function syncDomStoreFromCookie() {
        var list = loadEntriesFromCookie()
        var $root = ensureDomStore().empty()
        for (var i = 0; i < list.length; i++) domUpsertAtypEntry(list[i])
        log('[ATYP] syncDomStoreFromCookie done (len=' + list.length + ')')
        return list
      }

      function isAllowedBrand() {
        var ok = false
        $('.type-detail .product-top a[data-testid="productCardBrandName"] span').each(function () {
          var t = $(this).text().trim()
          if (allowedBrands.indexOf(t) > -1) {
            ok = true
            return false
          }
        })
        log('[ATYP] isAllowedBrand:', ok)
        return ok
      }

      function isMattressTitle() {
        var res = $('.p-detail-inner-header h1').text().toLowerCase().indexOf('matrace') > -1
        log('[ATYP] isMattressTitle:', res)
        return res
      }

      function getCleanProductNameFromH1() {
        var name = clean($('.p-detail-inner-header h1').text())
        log('[ATYP] productName:', name)
        return name
      }

      function getRozmerLabels() {
        return $('.choose-parameters-wrap.rozmer .labels-container label')
      }

      function collectVariantSizes() {
        var sizes = []
        try {
          var $labels = getRozmerLabels()
          $labels.each(function () {
            var m = parseSizeAnywhere($(this).text())
            if (m) sizes.push(m)
          })
          $('#parameter-id-6 option').each(function () {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2) sizes.push(m2)
          })
          var seen = {},
            uniq = []
          for (var i = 0; i < sizes.length; i++) {
            var key = sizes[i].w + 'x' + sizes[i].h
            if (!seen[key]) {
              seen[key] = true
              uniq.push(sizes[i])
            }
          }
          log('[ATYP] collectVariantSizes uniq=', uniq.length, uniq)
          return uniq
        } catch (e) {
          err('[ATYP] collectVariantSizes error:', e)
          return []
        }
      }

      function getMaxWidthFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var maxW = 0
        for (var i = 0; i < list.length; i++) if (list[i].w > maxW) maxW = list[i].w
        return maxW || null
      }

      function getMaxHeightFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var maxH = 0
        for (var i = 0; i < list.length; i++) if (list[i].h > maxH) maxH = list[i].h
        return maxH || null
      }

      function getMinWidthFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var minW = Infinity
        for (var i = 0; i < list.length; i++) if (list[i].w < minW) minW = list[i].w
        return minW === Infinity ? null : minW
      }

      function getMinHeightFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var minH = Infinity
        for (var i = 0; i < list.length; i++) if (list[i].h < minH) minH = list[i].h
        return minH === Infinity ? null : minH
      }

      function getSmallestVariantByArea() {
        var smallest = null,
          pool = []
        var $labels = getRozmerLabels()
        $labels.each(function () {
          var m = parseSizeAnywhere($(this).text())
          if (m) pool.push({ $radio: $(this).find('input[type=radio]'), w: m.w, h: m.h, area: m.w * m.h })
        })
        if (!pool.length) {
          $('#parameter-id-6 option').each(function () {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2) pool.push({ $radio: $(), w: m2.w, h: m2.h, area: m2.w * m2.h, value: $(this).val() })
          })
        }
        for (var i = 0; i < pool.length; i++) {
          if (!smallest || pool[i].area < smallest.area) smallest = pool[i]
        }
        return smallest
      }

      function selectExactVariant(w, h) {
        var $labels = getRozmerLabels(),
          found = false
        $labels.each(function () {
          var m = parseSizeAnywhere($(this).text())
          if (m && m.w === w && m.h === h) {
            var $r = $(this).find('input[type=radio]')
            if ($r.length) {
              $r.trigger('click')
              found = true
            }
            return false
          }
        })
        if (found) return true
        var $sel = $('#parameter-id-6')
        if ($sel.length) {
          $sel.find('option').each(function () {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2 && m2.w === w && m2.h === h) {
              $sel.val($(this).val()).trigger('input').trigger('change')
              $(document).trigger('ShoptetVariantChanged')
              found = true
              return false
            }
          })
        }
        return found
      }

      function selectCeilOrNearest(inputW, inputH) {
        try {
          var $labels = getRozmerLabels(),
            vars = []
          $labels.each(function () {
            var m = parseSizeAnywhere($(this).text())
            if (!m) return
            vars.push({ $radio: $(this).find('input[type=radio]'), w: m.w, h: m.h, area: m.w * m.h })
          })
          if (!vars.length) {
            $('#parameter-id-6 option').each(function () {
              var m2 = parseSizeAnywhere($(this).text().trim())
              if (m2) vars.push({ $radio: $(), w: m2.w, h: m2.h, area: m2.w * m2.h, value: $(this).val() })
            })
          }
          if (!vars.length) {
            log('[ATYP] selectCeilOrNearest: no variants')
            return false
          }

          // přesná shoda
          for (var i = 0; i < vars.length; i++) {
            if (vars[i].w === inputW && vars[i].h === inputH) {
              if (vars[i].$radio && vars[i].$radio.length) vars[i].$radio.trigger('click')
              else if (typeof vars[i].value !== 'undefined') {
                var $sel0 = $('#parameter-id-6')
                if ($sel0.length) {
                  $sel0.val(vars[i].value).trigger('input').trigger('change')
                  $(document).trigger('ShoptetVariantChanged')
                }
              }
              return true
            }
          }

          // „ceil“ — vyber variantu s w>=inputW a h>=inputH; nejmenší přesah vyhrává
          var ge = []
          for (var j = 0; j < vars.length; j++) if (vars[j].w >= inputW && vars[j].h >= inputH) ge.push(vars[j])
          if (ge.length) {
            ge.sort(function (a, b) {
              var da = a.w - inputW + (a.h - inputH),
                db = b.w - inputW + (b.h - inputH)
              if (da !== db) return da - db
              var dWa = a.w - inputW,
                dWb = b.w - inputW
              if (dWa !== dWb) return dWa - dWb
              return a.area - b.area
            })
            if (ge[0].$radio && ge[0].$radio.length) ge[0].$radio.trigger('click')
            else if (typeof ge[0].value !== 'undefined') {
              var $sel1 = $('#parameter-id-6')
              if ($sel1.length) {
                $sel1.val(ge[0].value).trigger('input').trigger('change')
                $(document).trigger('ShoptetVariantChanged')
              }
            }
            return true
          }

          // fallback „nejbližší“ (když neexistuje žádná s oběma rozměry >=)
          var best = null,
            min = Infinity
          for (var k = 0; k < vars.length; k++) {
            var v = vars[k],
              diff = Math.abs(v.w - inputW) + Math.abs(v.h - inputH)
            if (
              diff < min ||
              (diff === min && Math.abs(v.w - inputW) < Math.abs((best ? best.w : Infinity) - inputW)) ||
              (diff === min &&
                Math.abs(v.w - inputW) === Math.abs((best ? best.w : Infinity) - inputW) &&
                v.area < (best ? best.area : Infinity))
            ) {
              min = diff
              best = v
            }
          }
          if (best) {
            if (best.$radio && best.$radio.length) best.$radio.trigger('click')
            else if (typeof best.value !== 'undefined') {
              var $sel2 = $('#parameter-id-6')
              if ($sel2.length) {
                $sel2.val(best.value).trigger('input').trigger('change')
                $(document).trigger('ShoptetVariantChanged')
              }
            }
            return true
          }
          return false
        } catch (e) {
          err('[ATYP] selectCeilOrNearest error:', e)
          return false
        }
      }

      // === NOVÉ: inline upozornění jako první prvek v .p-info-wrapper ===
      ; (function ensureAtypInlineStyle() {
        if (!document.getElementById('atyp-inline-style')) {
          var css = [
            '.atyp-inline{display:flex;align-items:flex-start;gap:.75rem; order: 4; margin: 0; padding:12px 14px;border:1px solid #bee5eb;background:#d1ecf1;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,.05);font-weight:600;line-height:1.35}',
            '.atyp-inline .atyp-icon{flex:0 0 auto;width:20px;height:20px;line-height:20px;text-align:center;font-weight:700}',
            '.atyp-inline .atyp-body{flex:1 1 auto}',
            '.atyp-inline a{text-decoration:underline}',
            '.atyp-inline[data-hidden="1"]{display:none}',
            '.atyp-inline .msg{display:none!important}',
          ].join('')
          var el = document.createElement('style')
          el.id = 'atyp-inline-style'
          el.textContent = css
          document.head.appendChild(el)
        }
      })()

      function showAtypAlert() {
        var $wrap = $('.type-detail .p-info-wrapper')
        if (!$wrap.length) {
          warn('[ATYP] .p-info-wrapper nenalezen')
          return
        }
        var $box = $wrap.children('#atyp-inline')
        if (!$box.length) {
          $box = $(
            '<div id="atyp-inline" class="atyp-inline" role="status" aria-live="polite" data-hidden="0">' +
            '<div class="atyp-icon">ℹ️</div>' +
            '<div class="atyp-body">' +
            '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>' +
            '</div>' +
            '</div>'
          )
          $wrap.prepend($box)
        } else {
          $box.find('.msg').remove()
          if (!$box.find('.hint').length) {
            $box
              .find('.atyp-body')
              .append(
                '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>'
              )
          }
          $box.attr('data-hidden', '0')
        }
        $('#atyp-alert').remove()
      }

      function hideAtypAlert() {
        var $box = $('.type-detail .p-info-wrapper').children('#atyp-inline')
        if ($box.length) $box.attr('data-hidden', '1')
        $('#atyp-alert').remove()
      }

      ; (function migrateAtypInlineMarkupOnce() {
        var $box = $('.type-detail .p-info-wrapper').children('#atyp-inline')
        if ($box.length) {
          $box.find('.msg').remove()
          if (!$box.find('.hint').length) {
            $box
              .find('.atyp-body')
              .append(
                '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>'
              )
          }
        }
      })()

      function setDetailWrapperHidden(hidden) {
        var $el = $('.type-detail .p-info-wrapper .detail-wrapper')
        if (!$el.length) return
        if (hidden) {
          $el.attr('data-atyp-hidden', '1').css('display', 'none')
        } else {
          if ($el.attr('data-atyp-hidden')) {
            $el.css('display', '').removeAttr('data-atyp-hidden')
          }
        }
      }

      function clearLegacyStorageKeys() {
        try {
          if (!window.localStorage) return
          var toDelete = []
          for (var i = 0; i < localStorage.length; i++) {
            var k = localStorage.key(i)
            if (k && k.indexOf(STORAGE_PREFIX) === 0) toDelete.push(k)
          }
          toDelete.forEach(function (k) {
            localStorage.removeItem(k)
          })
          if (toDelete.length) log('[ATYP] cleared legacy localStorage keys:', toDelete.length)
        } catch (e) {
          warn('[ATYP] clearLegacyStorageKeys fail', e)
        }
      }

      function setVariantVisibility($row, hasAtyp) {
        var $v = $row.find('.main-link-variant, [data-testid="cartWidgetVariantName"]')
        if (!$v.length) return
        if (hasAtyp) {
          $v.each(function () {
            $(this).attr('data-atyp-hidden', '1').hide()
          })
        } else {
          $v.each(function () {
            var $el = $(this)
            if ($el.attr('data-atyp-hidden') === '1') {
              $el.removeAttr('data-atyp-hidden').show()
            }
          })
        }
      }

      function getActiveVariantSize() {
        var txt = $('.choose-parameters-wrap.rozmer .labels-container label.active, .choose-parameters-wrap.rozmer .labels-container label.selected')
          .text()
          .trim()
        if (!txt) {
          var $sel = $('#parameter-id-6')
          if ($sel.length) txt = $sel.find('option:selected').text().trim()
        }
        var m = parseSizeAnywhere(txt)
        return m || null
      }

      function getMaxHeightForWidth(width) {
        var list = collectVariantSizes()
        var maxH = null
        for (var i = 0; i < list.length; i++) {
          if (list[i].w === width) {
            if (maxH === null || list[i].h > maxH) maxH = list[i].h
          }
        }
        return maxH
      }

      function hasVariantAtLeast(minW, minH) {
        var list = collectVariantSizes()
        for (var i = 0; i < list.length; i++) {
          if (list[i].w >= minW && list[i].h >= minH) return true
        }
        return false
      }

      // === Inicializace na detailu matrací (admin + povolené značky + title obsahuje "matrace")
      if ($('body').hasClass('admin-logged') && isAllowedBrand() && isMattressTitle()) {
        log('[ATYP] init on product detail')
        if (!$('#custom-size-picker-style').length) {
          $('head').append(
            '<style id="custom-size-picker-style">#custom-size-picker[data-state="open"]{display:grid!important;opacity:1!important;visibility:visible!important;height:auto!important}#custom-size-picker[data-state="closed"]{display:none!important}.type-detail .master-radio-wrapper{overflow:visible!important}</style>'
          )
        }

        // UI prvky (šířka+délka)
        $(

          '<div id="custom-size-picker" data-state="closed">' +
          ' <label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>' +
          ' <label><span>délka</span><input type="number" id="input-height" min="0"><span>cm</span></label>' +
          '</div>'
        ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer')
        ensureDomStore()
        var pickerWantedOpen = false

        function syncPickerVisualWithState() {
          $('#custom-size-picker').attr('data-state', pickerWantedOpen ? 'open' : 'closed')
        }

        function openPicker() {
          pickerWantedOpen = true
          syncPickerVisualWithState()
        }

        function closePicker() {
          pickerWantedOpen = false
          syncPickerVisualWithState()
        }

        $(document)
          .off('click', '#toggle-size-picker')
          .on('click', '#toggle-size-picker', function (e) {
            e.preventDefault()
            pickerWantedOpen = !pickerWantedOpen
            syncPickerVisualWithState()
            if (pickerWantedOpen) {
              var w = document.getElementById('input-width')
              if (w)
                setTimeout(function () {
                  try {
                    w.focus()
                  } catch (e) { }
                }, 0)
            }
            return false
          })

        function mountPickerIfMissing() {
          if (!$('#custom-size-picker').length) {
            $(
              '<div id="custom-size-picker" data-state="closed">' +
              ' <label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>' +
              ' <label><span>délka</span><input type="number" id="input-height" min="0"><span>cm</span></label>' +
              '</div>'
            ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer')
            log('[ATYP] mountPickerIfMissing -> mounted')
          }
        }

        function forcePickerOpenIfWanted() {
          mountPickerIfMissing()
          if (pickerWantedOpen) $('#custom-size-picker').attr('data-state', 'open')
        }

        $(document).on('ShoptetVariantChanged ShoptetDOMUpdated', function () {
          setTimeout(forcePickerOpenIfWanted, 0)
          setTimeout(forcePickerOpenIfWanted, 120)
          setTimeout(forcePickerOpenIfWanted, 360)
        })
        if ('MutationObserver' in window) {
          var mo1 = new MutationObserver(function () {
            setTimeout(forcePickerOpenIfWanted, 0)
          })
          mo1.observe(document.body, { childList: true, subtree: true })
        }
        $(document)
          .off('click', '.choose-parameters-wrap.rozmer .labels-container label')
          .on('click', '.choose-parameters-wrap.rozmer .labels-container label', function (e) {
            if (e.isTrigger) return
            if (!(e.originalEvent && e.originalEvent.isTrusted)) return
            closePicker()
          })

        // --- hlavní onInput
        var tmr

        function onInput() {
          clearTimeout(tmr)
          tmr = setTimeout(function () {
            try {
              var W = (function () {
                var v = $('#input-width').val()
                return v === '' ? null : parseInt(v, 10)
              })()
              var H = (function () {
                var v = $('#input-height').val()
                return v === '' ? null : parseInt(v, 10)
              })()
              var hasW = typeof W === 'number' && !isNaN(W)
              var hasH = typeof H === 'number' && !isNaN(H)

              var maxW = getMaxWidthFromVariants()
              var maxHGlobal = getMaxHeightFromVariants()

              var active = getActiveVariantSize()
              var baseWidth = hasW ? W : active ? active.w : null
              var maxHForBaseWidth = baseWidth != null ? getMaxHeightForWidth(baseWidth) : null

              var minW = getMinWidthFromVariants()
              var minH = getMinHeightFromVariants()

              var widthTooBig = hasW && maxW !== null && W > maxW
              var lengthTooBig
              if (hasH) {
                if (baseWidth != null) {
                  lengthTooBig = !hasVariantAtLeast(baseWidth, H)
                } else {
                  lengthTooBig = maxHGlobal !== null ? H > maxHGlobal : false
                }
              } else {
                lengthTooBig = false
              }

              log(
                '[ATYP] dims -> W:',
                W,
                'H:',
                H,
                '| activeW:',
                active ? active.w : null,
                '| baseWidth:',
                baseWidth,
                '| maxW:',
                maxW,
                '| maxHForBaseWidth:',
                maxHForBaseWidth,
                '| maxHGlobal:',
                maxHGlobal,
                '| widthTooBig:',
                widthTooBig,
                '| lengthTooBig:',
                lengthTooBig
              )

              if (widthTooBig || lengthTooBig) {
                showAtypAlert()
                setDetailWrapperHidden(true)
              } else {
                hideAtypAlert()
                setDetailWrapperHidden(false)
              }

              // při potvrzené dvojici W/H volíme „ceil nebo nejbližší“ + uložíme vazbu
              if (hasW && hasH) {
                var picked = selectCeilOrNearest(W, H)
                if (picked) {
                  setTimeout(function () {
                    try {
                      var chosen = getActiveVariantSize()
                      if (!chosen) return
                      var cleanName = getCleanProductNameFromH1()
                      var skuNow = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
                      var entry = {
                        width: W,
                        height: H,
                        bindW: chosen.w,
                        bindH: chosen.h,
                        cleanProductName: cleanName,
                        sku: skuNow || '',
                        source: 'ceil-or-nearest',
                      }
                      upsertEntryToCookie(entry)
                      syncDomStoreFromCookie()
                      log('[ATYP] ceil-or-nearest -> saved user dims with bind:', entry)
                    } catch (e) {
                      err('[ATYP] ceil-or-nearest save error:', e)
                    }
                  }, 150)
                }
              }
            } catch (e) {
              err('[ATYP] onInput error:', e)
            }
          }, 220)
        }

        $('#input-width, #input-height').on('input', onInput)
        setTimeout(onInput, 200)

        var ADD_TO_CART_SELECTORS = [
          '.p-to-cart .btn',
          '.product-detail form[action*="cart"] button[type=submit]',
          'form[action*="cart"] .btn[type=submit]',
          '#product-detail-form .btn[type=submit]',
          '.btn-to-cart',
        ].join(',')
        $(document)
          .off('click.atypAdd', ADD_TO_CART_SELECTORS)
          .on('click.atypAdd', ADD_TO_CART_SELECTORS, function () {
            try {
              var cleanName = getCleanProductNameFromH1()
              if (!cleanName) return

              // před uložením nového záznamu pro tenhle produkt vyčistíme staré non-cart entrée
              var productSlugKey = slug(cleanName)
              pruneNonCartEntriesForProduct(productSlugKey)

              var wRaw = $('#input-width').val(),
                hRaw = $('#input-height').val()
              var W = wRaw === '' ? null : parseInt(wRaw, 10)
              var H = hRaw === '' ? null : parseInt(hRaw, 10)

              if (typeof W === 'number' && !isNaN(W) && typeof H === 'number' && !isNaN(H)) {
                var entryInput = {
                  width: W,
                  height: H,
                  cleanProductName: cleanName,
                  sku: '',
                  source: 'add-to-cart',
                }
                var minW = getMinWidthFromVariants(),
                  minH = getMinHeightFromVariants()
                if (minW != null && minH != null && (W < minW || H < minH)) {
                  var sm = getSmallestVariantByArea()
                  if (sm) {
                    entryInput.bindW = sm.w
                    entryInput.bindH = sm.h
                  }
                }
                var skuNow = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
                if (skuNow) entryInput.sku = skuNow
                upsertEntryToCookie(entryInput)
                syncDomStoreFromCookie()
                log('[ATYP] saved (input dims) before add-to-cart:', entryInput)
                return
              }

              var pickedText = $(
                '.choose-parameters-wrap.rozmer .labels-container label.active, .choose-parameters-wrap.rozmer .labels-container label.selected'
              ).text()
              if (!pickedText) {
                var $sel = $('#parameter-id-6')
                if ($sel.length) pickedText = $sel.find('option:selected').text()
              }
              var m = parseSizeAnywhere(pickedText)
              if (m) {
                var skuNow2 = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
                var entryVar = {
                  width: m.w,
                  height: m.h,
                  cleanProductName: cleanName,
                  sku: skuNow2 || '',
                  source: 'add-to-cart',
                }
                upsertEntryToCookie(entryVar)
                syncDomStoreFromCookie()
                log('[ATYP] saved (variant dims) before add-to-cart:', entryVar)
              }
            } catch (e) {
              err('[ATYP] add-to-cart save error:', e)
            }
          })
      }

      function waitFor(selector, opts) {
        opts = opts || {}
        var tries = typeof opts.tries === 'number' ? opts.tries : 60
        var interval = typeof opts.interval === 'number' ? opts.interval : 150
        return new Promise(function (resolve) {
          var left = tries
            ; (function tick() {
              if ($(selector).length) return resolve(true)
              if (--left <= 0) return resolve(false)
              setTimeout(tick, interval)
            })()
        })
      }

      // === id--16 (rekap / sidebar košíku: dopsat info k položkám) ===
      if ($('body').hasClass('id--16')) {
        ; (async function () {
          if (!$('#custom-note-style').length)
            $('head').append(
              '<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>'
            )
          var storedArr = syncDomStoreFromCookie()
          await waitFor(
            '[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item'
          )
          setTimeout(function () {
            var $rows = $(
              '[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item'
            )
            $rows.each(function () {
              var $row = $(this)

              function findAtypForCartItem($row, storedArrDomFirst) {
                try {
                  var productName = clean(
                    $row
                      .find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a')
                      .first()
                      .text() ||
                    $row
                      .find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name')
                      .first()
                      .text()
                  )
                  var productSlugCandidate = slug(productName)
                  var variantStr =
                    clean(
                      $row
                        .find(
                          '[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants'
                        )
                        .first()
                        .text()
                    ) || clean($row.text())
                  var dim = parseSizeAnywhere(variantStr)
                  var itemSku = clean(
                    $row.attr('data-micro-sku') ||
                    $row.find('[data-micro-sku]').attr('data-micro-sku') ||
                    $row.find('.p-code, .product-code, .code, .sku')
                      .first()
                      .text()
                  )
                  if (itemSku) itemSku = itemSku.trim()

                  // 1) Přímá shoda productSlug + rozměr
                  if (productSlugCandidate && dim) {
                    for (var i = 0; i < storedArrDomFirst.length; i++) {
                      var x0 = storedArrDomFirst[i]
                      if (x0.productSlug === productSlugCandidate && x0.width === dim.w && x0.height === dim.h) return x0
                    }
                  }

                  // 1a) Bind shoda
                  if (productSlugCandidate && dim) {
                    for (var b = 0; b < storedArrDomFirst.length; b++) {
                      var xb = storedArrDomFirst[b]
                      var sameProdB = xb.productSlug === productSlugCandidate || looseMatch(xb.cleanProductName, productName)
                      if (!sameProdB) continue
                      if (xb.bindW && xb.bindH && xb.bindW === dim.w && xb.bindH === dim.h) return xb
                    }
                  }

                  // 2) Jméno + (rozměr shodný / prohozený)
                  if (productName) {
                    for (var j = 0; j < storedArrDomFirst.length; j++) {
                      var x1 = storedArrDomFirst[j]
                      var ok =
                        looseMatch(x1.cleanProductName, productName) &&
                        (!dim ||
                          ((x1.width === dim.w && x1.height === dim.h) ||
                            (x1.width === dim.h && x1.height === dim.w)))
                      if (ok) return x1
                    }
                  }

                  // 3) SKU
                  if (itemSku) {
                    if (dim) {
                      for (var m = 0; m < storedArrDomFirst.length; m++) {
                        var x3 = storedArrDomFirst[m]
                        var ok3 =
                          x3.sku &&
                          x3.sku.trim() === itemSku &&
                          ((x3.width === dim.w && x3.height === dim.h) ||
                            (x3.width === dim.h && x3.height === dim.w))
                        if (ok3) return x3
                      }
                    }
                    var skuMatches = []
                    for (var n = 0; n < storedArrDomFirst.length; n++) {
                      var x4 = storedArrDomFirst[n]
                      if (x4.sku && x4.sku.trim() === itemSku) skuMatches.push(x4)
                    }
                    if (skuMatches.length === 1) return skuMatches[0]
                    if (productName) {
                      for (var p = 0; p < storedArrDomFirst.length; p++) {
                        var x5 = storedArrDomFirst[p]
                        if (x5.sku && x5.sku.trim() === itemSku && looseMatch(x5.cleanProductName, productName)) return x5
                      }
                    }
                  }

                  // 4) Jméno + rozměr
                  if (productName && dim) {
                    for (var k = 0; k < storedArrDomFirst.length; k++) {
                      var x2 = storedArrDomFirst[k]
                      var ok2 =
                        looseMatch(x2.cleanProductName, productName) &&
                        ((x2.width === dim.w && x2.height === dim.h) ||
                          (x2.width === dim.h && x2.height === dim.w))
                      if (ok2) return x2
                    }
                  }

                  // 5) Jméno fallback
                  if (productName) {
                    var sameProd = []
                    for (var q = 0; q < storedArrDomFirst.length; q++) {
                      var x6 = storedArrDomFirst[q]
                      if (looseMatch(x6.cleanProductName, productName) || x6.productSlug === productSlugCandidate)
                        sameProd.push(x6)
                    }
                    var distinct = {}
                    for (var r = 0; r < sameProd.length; r++)
                      distinct[sameProd[r].width + 'x' + sameProd[r].height] = true
                    var keys = Object.keys(distinct)
                    if (!dim && keys.length === 1) return sameProd[0]
                    if (sameProd.length) return sameProd[0]
                  }

                  return null
                } catch (e) {
                  err('[ATYP] findAtypForCartItem error:', e)
                  return null
                }
              }

              var entry = findAtypForCartItem($row, readDomStore())
              var $name = $row
                .find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name')
                .first()
              var $mount = $name.length ? $name : $row

              // RESET
              $mount.find('.custom-note').remove()
              setVariantVisibility($row, false)

              if (!entry) return

              var msg = 'Atypický rozměr ' + entry.width + 'x' + entry.height + ' cm'
              var $after = $mount.find('a.main-link, a').first()
              var $note = $('<span class="custom-note atyp-note"></span>').text(msg)
              if ($after.length) {
                $note.insertAfter($after)
              } else {
                $mount.append($note)
              }

              setVariantVisibility($row, true)
            })
          }, 80)
        })()
      }

      // === id--9 (přehled v košíku – tabulka) ===
      if ($('body').hasClass('id--9')) {
        ; (async function () {
          if (!$('#custom-note-style').length)
            $('head').append(
              '<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>'
            )

          function renderCartNotes() {
            syncDomStoreFromCookie()
            var storedArrDom = readDomStore()

            function msgOf(e) {
              return 'Atypický rozměr ' + e.width + 'x' + e.height + ' cm'
            }

            $('.cart-table tr.removeable, .cart-table tr[data-micro="cartItem"]').each(function () {
              var $tr = $(this)

              function findAtypForCartItem($row, storedArrDomFirst) {
                try {
                  var productName = clean(
                    $row
                      .find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a')
                      .first()
                      .text() ||
                    $row
                      .find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name')
                      .first()
                      .text()
                  )
                  var productSlugCandidate = slug(productName)
                  var variantStr =
                    clean(
                      $row
                        .find(
                          '[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants'
                        )
                        .first()
                        .text()
                    ) || clean($row.text())
                  var dim = parseSizeAnywhere(variantStr)
                  var itemSku = clean(
                    $row.attr('data-micro-sku') ||
                    $row.find('[data-micro-sku]').attr('data-micro-sku') ||
                    $row.find('.p-code, .product-code, .code, .sku')
                      .first()
                      .text()
                  )
                  if (itemSku) itemSku = itemSku.trim()

                  if (productSlugCandidate && dim) {
                    for (var i = 0; i < storedArrDomFirst.length; i++) {
                      var x0 = storedArrDomFirst[i]
                      if (x0.productSlug === productSlugCandidate && x0.width === dim.w && x0.height === dim.h) return x0
                    }
                  }

                  // Bind shoda
                  if (productSlugCandidate && dim) {
                    for (var b = 0; b < storedArrDomFirst.length; b++) {
                      var xb = storedArrDomFirst[b]
                      var sameProdB = xb.productSlug === productSlugCandidate || looseMatch(xb.cleanProductName, productName)
                      if (!sameProdB) continue
                      if (xb.bindW && xb.bindH && xb.bindW === dim.w && xb.bindH === dim.h) return xb
                    }
                  }

                  if (productName) {
                    for (var j = 0; j < storedArrDomFirst.length; j++) {
                      var x1 = storedArrDomFirst[j]
                      var ok =
                        looseMatch(x1.cleanProductName, productName) &&
                        (!dim ||
                          ((x1.width === dim.w && x1.height === dim.h) ||
                            (x1.width === dim.h && x1.height === dim.w)))
                      if (ok) return x1
                    }
                  }

                  if (itemSku) {
                    if (dim) {
                      for (var m = 0; m < storedArrDomFirst.length; m++) {
                        var x3 = storedArrDomFirst[m]
                        var ok3 =
                          x3.sku &&
                          x3.sku.trim() === itemSku &&
                          ((x3.width === dim.w && x3.height === dim.h) ||
                            (x3.width === dim.h && x3.height === dim.w))
                        if (ok3) return x3
                      }
                    }
                    var skuMatches = []
                    for (var n = 0; n < storedArrDomFirst.length; n++) {
                      var x4 = storedArrDomFirst[n]
                      if (x4.sku && x4.sku.trim() === itemSku) skuMatches.push(x4)
                    }
                    if (skuMatches.length === 1) return skuMatches[0]
                    if (productName) {
                      for (var p = 0; p < storedArrDomFirst.length; p++) {
                        var x5 = storedArrDomFirst[p]
                        if (x5.sku && x5.sku.trim() === itemSku && looseMatch(x5.cleanProductName, productName)) return x5
                      }
                    }
                  }

                  if (productName && dim) {
                    for (var k = 0; k < storedArrDomFirst.length; k++) {
                      var x2 = storedArrDomFirst[k]
                      var ok2 =
                        looseMatch(x2.cleanProductName, productName) &&
                        ((x2.width === dim.w && x2.height === dim.h) ||
                          (x2.width === dim.h && x2.height === dim.w))
                      if (ok2) return x2
                    }
                  }

                  if (productName) {
                    var sameProd = []
                    for (var q = 0; q < storedArrDomFirst.length; q++) {
                      var x6 = storedArrDomFirst[q]
                      if (looseMatch(x6.cleanProductName, productName) || x6.productSlug === productSlugCandidate)
                        sameProd.push(x6)
                    }
                    var distinct = {}
                    for (var r = 0; r < sameProd.length; r++)
                      distinct[sameProd[r].width + 'x' + sameProd[r].height] = true
                    var keys = Object.keys(distinct)
                    if (!dim && keys.length === 1) return sameProd[0]
                    if (sameProd.length) return sameProd[0]
                  }

                  return null
                } catch (e) {
                  err('[ATYP] findAtypForCartItem(cart) error:', e)
                  return null
                }
              }

              var entry = findAtypForCartItem($tr, storedArrDom)
              var $nameCell = $tr
                .find('[data-micro="cartItemName"], .p-name, .cart-item-name, .product-name, .name')
                .first()
              var $mount = $nameCell.length ? $nameCell : $tr

              // RESET
              $mount.find('.custom-note').remove()
              setVariantVisibility($tr, false)

              if (!entry) return

              var $link = $mount.find('a, .main-link').first()
              var $note = $('<div class="custom-note atyp-note"></div>').text(msgOf(entry))
              if ($link.length) {
                $note.insertAfter($link)
              } else {
                $mount.append($note)
              }

              setVariantVisibility($tr, true)
            })
          }

          var ok = await waitFor('.cart-table tr.removeable, .cart-table tr[data-micro="cartItem"]')
          if (ok) setTimeout(renderCartNotes, 100)
          $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function () {
            setTimeout(renderCartNotes, 80)
          })
          var target = document.querySelector('#content') || document.body
          if (target && 'MutationObserver' in window) {
            var mo3 = new MutationObserver(function () {
              setTimeout(renderCartNotes, 50)
            })
            mo3.observe(target, { childList: true, subtree: true })
          }
        })()
      }

      // === id--19 (widget / mini-košík apod.) ===
      if ($('body').hasClass('id--19')) {
        ; (async function () {
          await waitFor('[data-testid="cartWidgetVariantName"], .main-link-variant, [data-micro="cartItem"], .cart-items .cart-item')

          function refreshVariantHides() {
            var $rows = $(
              '[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item, [data-testid="cartWidgetItem"], .cart-widget-item, .cart-widget .item, tr'
            )
            $rows.each(function () {
              var $row = $(this)
              var hasAtyp = $row.find('.atyp-note').length > 0
              setVariantVisibility($row, hasAtyp)
            })
          }

          refreshVariantHides()

          $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function () {
            setTimeout(refreshVariantHides, 50)
          })
          if ('MutationObserver' in window) {
            var mo = new MutationObserver(function () {
              setTimeout(refreshVariantHides, 50)
            })
            mo.observe(document.body, { childList: true, subtree: true })
          }
        })()
      }

      // === id--17 (pokladna: POZNÁMKA) – propsat hodnoty POUZE pro položky aktuálního košíku do #remark ===
      if ($('body').hasClass('id--17')) {
        function _clean(t) {
          return String(t || '')
            .replace(/\s+/g, ' ')
            .trim()
        }

        function _slug(s) {
          s = String(s || '')
          try {
            s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
          } catch (e) { }
          return s
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
        }

        function _loadLatestFromCookie() {
          try {
            var raw = readCookie(COOKIE_NAME)
            if (!raw) return []
            var arr = JSON.parse(raw)
            if (!Array.isArray(arr)) return []
            arr.sort(function (a, b) {
              return (b.savedAt || 0) - (a.savedAt || 0)
            })
            return arr
          } catch (e) {
            return []
          }
        }

        function _ensureNoteOpen() {
          var $toggle = $('#add-note')
          var $wrap = $('#note')
          if ($toggle.length && !$toggle.prop('checked')) {
            $toggle.prop('checked', true).trigger('change')
          }
          if ($wrap.length) $wrap.removeClass('js-hidden').addClass('visible')
        }

        function _getCartRowsOnCheckout() {
          return $(
            '[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item'
          )
        }

        function _findAtypForCartItemCheckout($row, storedArrDomFirst) {
          try {
            var productName = _clean(
              $row
                .find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a')
                .first()
                .text() ||
              $row
                .find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name')
                .first()
                .text()
            )
            var productSlugCandidate = _slug(productName)
            var variantStr =
              _clean(
                $row
                  .find(
                    '[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants'
                  )
                  .first()
                  .text()
              ) || _clean($row.text())
            var dim = parseSizeAnywhere(variantStr)
            var itemSku = _clean(
              $row.attr('data-micro-sku') ||
              $row.find('[data-micro-sku]').attr('data-micro-sku') ||
              $row.find('.p-code, .product-code, .code, .sku')
                .first()
                .text()
            )
            if (itemSku) itemSku = itemSku.trim()

            // 1) Přímá shoda productSlug + rozměr
            if (productSlugCandidate && dim) {
              for (var i = 0; i < storedArrDomFirst.length; i++) {
                var x0 = storedArrDomFirst[i]
                if (x0.productSlug === productSlugCandidate && x0.width === dim.w && x0.height === dim.h) return x0
              }
            }

            // 1a) Bind shoda
            if (productSlugCandidate && dim) {
              for (var b = 0; b < storedArrDomFirst.length; b++) {
                var xb = storedArrDomFirst[b]
                var sameProdB = xb.productSlug === productSlugCandidate || looseMatch(xb.cleanProductName, productName)
                if (!sameProdB) continue
                if (xb.bindW && xb.bindH && xb.bindW === dim.w && xb.bindH === dim.h) return xb
              }
            }

            // 2) Jméno + (rozměr shodný / prohozený)
            if (productName) {
              for (var j = 0; j < storedArrDomFirst.length; j++) {
                var x1 = storedArrDomFirst[j]
                var ok =
                  looseMatch(x1.cleanProductName, productName) &&
                  (!dim ||
                    ((x1.width === dim.w && x1.height === dim.h) ||
                      (x1.width === dim.h && x1.height === dim.w)))
                if (ok) return x1
              }
            }

            // 3) SKU
            if (itemSku) {
              if (dim) {
                for (var m = 0; m < storedArrDomFirst.length; m++) {
                  var x3 = storedArrDomFirst[m]
                  var ok3 =
                    x3.sku &&
                    x3.sku.trim() === itemSku &&
                    ((x3.width === dim.w && x3.height === dim.h) ||
                      (x3.width === dim.h && x3.height === dim.w))
                  if (ok3) return x3
                }
              }
              var skuMatches = []
              for (var n = 0; n < storedArrDomFirst.length; n++) {
                var x4 = storedArrDomFirst[n]
                if (x4.sku && x4.sku.trim() === itemSku) skuMatches.push(x4)
              }
              if (skuMatches.length === 1) return skuMatches[0]
              if (productName) {
                for (var p = 0; p < storedArrDomFirst.length; p++) {
                  var x5 = storedArrDomFirst[p]
                  if (x5.sku && x5.sku.trim() === itemSku && looseMatch(x5.cleanProductName, productName)) return x5
                }
              }
            }

            // 4) Jméno + rozměr
            if (productName && dim) {
              for (var k = 0; k < storedArrDomFirst.length; k++) {
                var x2 = storedArrDomFirst[k]
                var ok2 =
                  looseMatch(x2.cleanProductName, productName) &&
                  ((x2.width === dim.w && x2.height === dim.h) ||
                    (x2.width === dim.h && x2.height === dim.w))
                if (ok2) return x2
              }
            }

            // 5) Jméno fallback
            if (productName) {
              var sameProd = []
              for (var q = 0; q < storedArrDomFirst.length; q++) {
                var x6 = storedArrDomFirst[q]
                if (looseMatch(x6.cleanProductName, productName) || x6.productSlug === productSlugCandidate) sameProd.push(x6)
              }
              var distinct = {}
              for (var r = 0; r < sameProd.length; r++) distinct[sameProd[r].width + 'x' + sameProd[r].height] = true
              var keys = Object.keys(distinct)
              if (!dim && keys.length === 1) return sameProd[0]
              if (sameProd.length) return sameProd[0]
            }

            return null
          } catch (e) {
            err('[ATYP] findAtypForCartItem(checkout) error:', e)
            return null
          }
        }

        function _buildText() {
          // Načteme entries z cookies a přesuneme je do DOM store
          syncDomStoreFromCookie()
          var storedArrDom = readDomStore().filter(function (x) {
            return x && x.sessionId === SESSION_ID && x.width && x.height
          })
          if (!storedArrDom.length) return ''

          var $rows = _getCartRowsOnCheckout()
          if (!$rows.length) return ''

          var pickedEntries = []
          $rows.each(function () {
            var $row = $(this)
            var entry = _findAtypForCartItemCheckout($row, storedArrDom)
            if (entry) pickedEntries.push(entry)
          })

          if (!pickedEntries.length) return ''

          // dedupe na kombinaci PRODUKT + ROZMĚR (ale pouze z toho, co je opravdu v košíku)
          var seen = Object.create(null)
          var unique = []

          for (var i = 0; i < pickedEntries.length; i++) {
            var it = pickedEntries[i]
            if (!it || !it.cleanProductName || !it.width || !it.height) continue
            var baseSlug = it.productSlug || _slug(_clean(it.cleanProductName))
            var dimKey = it.width + 'x' + it.height
            var key = baseSlug + '::' + dimKey
            if (seen[key]) continue
            seen[key] = 1
            unique.push(it)
          }

          if (!unique.length) return ''

          return unique
            .map(function (x) {
              return 'Atypický rozměr ' + x.cleanProductName + ': ' + x.width + 'x' + x.height + ' cm'
            })
            .join('\n')
        }

        function _fillRemark() {
          var $remark = $('#remark')
          if (!$remark.length) return
          var txt = _buildText()
          if (!txt) return
          _ensureNoteOpen()
          $remark.val(txt)
        }

        // První naplnění po načtení
        setTimeout(_fillRemark, 400)

        // Reakce na změny košíku / DOM
        $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function () {
          setTimeout(_fillRemark, 150)
        })
      }
    }) // end $(function)
  })() // end waitForJqueryAndRun IIFE


  /**
  (function waitForJqueryAndRun() {
    if (typeof window.jQuery === 'undefined') {
      setTimeout(waitForJqueryAndRun, 100)
      return
    }
 
    $(function() {
 
      var allowedBrands = ['Dřevočal', 'MPO Matrace', 'Materasso', 'Magniflex', 'Moravia Comfort', 'Řešeto']
      var STORAGE_PREFIX = 'custom-mattress:' // historické – ponecháno pro kompatibilitu klíčů
      var ATYP_STORE_ID = 'atyp-store'
      var COOKIE_NAME = 'custom-mattress-entries'
      var COOKIE_MAX_AGE_DAYS = 14
      var COOKIE_MAX_ITEMS = 30
 
      // Session pro oddělení jedné návštěvy/košíku
      var SESSION_COOKIE_NAME = 'custom-mattress-session'
 
      // Texty alertů (ponechány kvůli kompatibilitě – aktuálně se ignorují)
      var ATYP_ALERT_BOTH_TOO_BIG = 'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_WIDTH_TOO_BIG = 'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_HEIGHT_TOO_BIG = 'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
      var ATYP_ALERT_DEFAULT = 'Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty" style="text-decoration:underline">kontaktujte nás</a>.'
 
      function log() {
        try {
          console.log.apply(console, arguments)
        } catch (e) {
        }
      }
 
      function warn() {
        try {
          console.warn.apply(console, arguments)
        } catch (e) {
        }
      }
 
      function err() {
        try {
          console.error.apply(console, arguments)
        } catch (e) {
        }
      }
 
      function clean(s) {
        return String(s || '').replace(/\s+/g, ' ').trim()
      }
 
      function nowTs() {
        return Date.now()
      }
 
      function slug(s) {
        s = String(s || '')
        try {
          s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
        } catch (e) {
        }
        return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
      }
 
      function makeKey(productName, w, h) {
        return STORAGE_PREFIX + slug(productName) + '--' + w + 'x' + h
      }
 
      function parseSizeAnywhere(txt) {
        var m = String(txt || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*(?:cm)?/i)
        return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : null
      }
 
      function looseMatch(a, b) {
        var A = slug(a), B = slug(b)
        if (!A || !B) return false
        if (A === B) return true
 
        function stripDims(t) {
          return t.replace(/-\d+(?:-\d+)?-?cm\b/g, '').replace(/-\d+-?cm\b/g, '').replace(/-\d{2,3}\b/g, '')
        }
 
        var As = stripDims(A), Bs = stripDims(B)
        return As === Bs || As.indexOf(Bs) > -1 || Bs.indexOf(As) > -1 || A.indexOf(B) > -1 || B.indexOf(A) > -1
      }
 
      function readCookie(name) {
        try {
          var parts = document.cookie.split('; ')
          for (var i = 0; i < parts.length; i++) {
            var p = parts[i]
            if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.substring(name.length + 1))
          }
        } catch (e) {
        }
        return ''
      }
 
      function writeCookie(name, value, days) {
        try {
          var d = new Date()
          d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
          var expires = 'expires=' + d.toUTCString()
          document.cookie = name + '=' + encodeURIComponent(value) + '; ' + expires + '; path=/; SameSite=Lax'
        } catch (e) {
          warn('[ATYP] writeCookie fail', e)
        }
      }
 
      function deleteCookie(name) {
        try {
          document.cookie = name + '=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax'
        } catch (e) {
          warn('[ATYP] deleteCookie fail', e)
        }
      }
 
      function ensureSessionId() {
        var sid = readCookie(SESSION_COOKIE_NAME)
        if (!sid) {
          sid = (Math.random().toString(36).slice(2) + Date.now().toString(36))
          writeCookie(SESSION_COOKIE_NAME, sid, COOKIE_MAX_AGE_DAYS)
        }
        return sid
      }
 
      var SESSION_ID = ensureSessionId()
 
      function loadEntriesFromCookie() {
        try {
          var raw = readCookie(COOKIE_NAME)
          if (!raw) return []
          var arr = JSON.parse(raw)
          if (!Array.isArray(arr)) return []
          arr.sort(function(a, b) {
            return (b.savedAt || 0) - (a.savedAt || 0)
          })
          return arr
        } catch (e) {
          warn('[ATYP] loadEntriesFromCookie parse fail', e)
          return []
        }
      }
 
      function saveEntriesToCookie(arr) {
        try {
          var pruned = (arr || []).slice(0, COOKIE_MAX_ITEMS)
          writeCookie(COOKIE_NAME, JSON.stringify(pruned), COOKIE_MAX_AGE_DAYS)
        } catch (e) {
          warn('[ATYP] saveEntriesToCookie fail', e)
        }
      }
 
      function upsertEntryToCookie(entry) {
        if (!entry || !entry.cleanProductName || !entry.width || !entry.height) return
        var list = loadEntriesFromCookie()
        var keySlug = slug(entry.cleanProductName)
 
        // doplň sessionId do entry
        entry.sessionId = SESSION_ID
 
        // odstranění naprostých duplikátů v rámci stejné session (produkt+rozměr+sku+bind)
        list = list.filter(function(it) {
          var sameProd = (it.productSlug === keySlug || looseMatch(it.cleanProductName, entry.cleanProductName))
          var sameDim = (it.width === entry.width && it.height === entry.height)
          var sameSku = !entry.sku || !it.sku ? true : (String(it.sku).trim() === String(entry.sku).trim())
          var sameBind = ((it.bindW || null) === (entry.bindW || null) && (it.bindH || null) === (entry.bindH || null))
          var sameSession = (it.sessionId === entry.sessionId)
          return !(sameProd && sameDim && sameSku && sameBind && sameSession)
        })
 
        // pokud ukládáme z "add-to-cart", smaž VŠECHNY starší položky stejného produktu v aktuální session
        if (entry.source === 'add-to-cart') {
          list = list.filter(function(it) {
            var sameSession = (it.sessionId === entry.sessionId)
            var sameProd = (it.productSlug === keySlug || looseMatch(it.cleanProductName, entry.cleanProductName))
            return !(sameSession && sameProd)
          })
        }
 
        var toSave = $.extend({}, entry, { savedAt: entry.savedAt || nowTs(), productSlug: keySlug })
        list.unshift(toSave)
        saveEntriesToCookie(list)
        log('[ATYP] upsertEntryToCookie (session-scoped):', toSave, '(list size:', list.length, ')')
      }
 
      function ensureDomStore() {
        var $el = $('#' + ATYP_STORE_ID)
        if (!$el.length) {
          $el = $('<div id="' + ATYP_STORE_ID + '" style="display:none" aria-hidden="true"></div>')
          $('body').append($el)
        }
        return $el
      }
 
      function destroyDomStore() {
        $('#' + ATYP_STORE_ID).remove()
      }
 
      window.addEventListener('pagehide', destroyDomStore)
      window.addEventListener('beforeunload', destroyDomStore)
 
      function domUpsertAtypEntry(entry) {
        var $root = ensureDomStore()
        var key = makeKey(entry.cleanProductName, entry.width, entry.height)
        var $old = $root.find('.atyp-item[data-key="' + key + '"]')
        var $node = $(
          '<div class="atyp-item" ' +
          ' data-key="' + key + '" ' +
          ' data-product="' + (entry.cleanProductName || '') + '" ' +
          ' data-product-slug="' + (entry.productSlug || '') + '" ' +
          ' data-width="' + entry.width + '" ' +
          ' data-height="' + entry.height + '" ' +
          ' data-bindw="' + (entry.bindW || '') + '" ' +
          ' data-bindh="' + (entry.bindH || '') + '" ' +
          ' data-sku="' + (entry.sku || '') + '" ' +
          ' data-source="' + (entry.source || '') + '" ' +
          ' data-savedat="' + (entry.savedAt || nowTs()) + '" ' +
          ' data-session="' + (entry.sessionId || '') + '"></div>'
        )
        if ($old.length) {
          $old.replaceWith($node)
        } else {
          $root.append($node)
        }
      }
 
      function readDomStore() {
        var $root = $('#' + ATYP_STORE_ID)
        if (!$root.length) return []
        var out = []
        $root.find('.atyp-item').each(function() {
          var $i = $(this)
          var width = parseInt($i.attr('data-width'), 10)
          var height = parseInt($i.attr('data-height'), 10)
          if (!width || !height) return
          var bindW = parseInt($i.attr('data-bindw'), 10)
          var bindH = parseInt($i.attr('data-bindh'), 10)
          out.push({
            cleanProductName: $i.attr('data-product') || '',
            productSlug: $i.attr('data-product-slug') || '',
            width: width, height: height,
            bindW: isNaN(bindW) ? null : bindW,
            bindH: isNaN(bindH) ? null : bindH,
            sku: $i.attr('data-sku') || '',
            source: $i.attr('data-source') || '',
            sessionId: $i.attr('data-session') || '',
            savedAt: parseInt($i.attr('data-savedat'), 10) || 0
          })
        })
        out.sort(function(a, b) {
          return (b.savedAt || 0) - (a.savedAt || 0)
        })
        return out
      }
 
      function syncDomStoreFromCookie() {
        var list = loadEntriesFromCookie()
        var $root = ensureDomStore().empty()
        for (var i = 0; i < list.length; i++) domUpsertAtypEntry(list[i])
        log('[ATYP] syncDomStoreFromCookie done (len=' + list.length + ')')
        return list
      }
 
      function isAllowedBrand() {
        var ok = false
        $('.type-detail .product-top a[data-testid="productCardBrandName"] span').each(function() {
          var t = $(this).text().trim()
          if (allowedBrands.indexOf(t) > -1) {
            ok = true
            return false
          }
        })
        log('[ATYP] isAllowedBrand:', ok)
        return ok
      }
 
      function isMattressTitle() {
        var res = $('.p-detail-inner-header h1').text().toLowerCase().indexOf('matrace') > -1
        log('[ATYP] isMattressTitle:', res)
        return res
      }
 
      function getCleanProductNameFromH1() {
        var name = clean($('.p-detail-inner-header h1').text())
        log('[ATYP] productName:', name)
        return name
      }
 
      function getRozmerLabels() {
        return $('.choose-parameters-wrap.rozmer .labels-container label')
      }
 
      function collectVariantSizes() {
        var sizes = []
        try {
          var $labels = getRozmerLabels()
          $labels.each(function() {
            var m = parseSizeAnywhere($(this).text())
            if (m) sizes.push(m)
          })
          $('#parameter-id-6 option').each(function() {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2) sizes.push(m2)
          })
          var seen = {}, uniq = []
          for (var i = 0; i < sizes.length; i++) {
            var key = sizes[i].w + 'x' + sizes[i].h
            if (!seen[key]) {
              seen[key] = true
              uniq.push(sizes[i])
            }
          }
          log('[ATYP] collectVariantSizes uniq=', uniq.length, uniq)
          return uniq
        } catch (e) {
          err('[ATYP] collectVariantSizes error:', e)
          return []
        }
      }
 
      function getMaxWidthFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var maxW = 0
        for (var i = 0; i < list.length; i++) if (list[i].w > maxW) maxW = list[i].w
        return maxW || null
      }
 
      function getMaxHeightFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var maxH = 0
        for (var i = 0; i < list.length; i++) if (list[i].h > maxH) maxH = list[i].h
        return maxH || null
      }
 
      function getMinWidthFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var minW = Infinity
        for (var i = 0; i < list.length; i++) if (list[i].w < minW) minW = list[i].w
        return (minW === Infinity) ? null : minW
      }
 
      function getMinHeightFromVariants() {
        var list = collectVariantSizes()
        if (!list.length) return null
        var minH = Infinity
        for (var i = 0; i < list.length; i++) if (list[i].h < minH) minH = list[i].h
        return (minH === Infinity) ? null : minH
      }
 
      function getSmallestVariantByArea() {
        var smallest = null, pool = []
        var $labels = getRozmerLabels()
        $labels.each(function() {
          var m = parseSizeAnywhere($(this).text())
          if (m) pool.push({ $radio: $(this).find('input[type=radio]'), w: m.w, h: m.h, area: m.w * m.h })
        })
        if (!pool.length) {
          $('#parameter-id-6 option').each(function() {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2) pool.push({ $radio: $(), w: m2.w, h: m2.h, area: m2.w * m2.h, value: $(this).val() })
          })
        }
        for (var i = 0; i < pool.length; i++) {
          if (!smallest || pool[i].area < smallest.area) smallest = pool[i]
        }
        return smallest
      }
 
      function selectExactVariant(w, h) {
        var $labels = getRozmerLabels(), found = false
        $labels.each(function() {
          var m = parseSizeAnywhere($(this).text())
          if (m && m.w === w && m.h === h) {
            var $r = $(this).find('input[type=radio]')
            if ($r.length) {
              $r.trigger('click')
              found = true
            }
            return false
          }
        })
        if (found) return true
        var $sel = $('#parameter-id-6')
        if ($sel.length) {
          $sel.find('option').each(function() {
            var m2 = parseSizeAnywhere($(this).text().trim())
            if (m2 && m2.w === w && m2.h === h) {
              $sel.val($(this).val()).trigger('input').trigger('change')
              $(document).trigger('ShoptetVariantChanged')
              found = true
              return false
            }
          })
        }
        return found
      }
 
      function selectCeilOrNearest(inputW, inputH) {
        try {
          var $labels = getRozmerLabels(), vars = []
          $labels.each(function() {
            var m = parseSizeAnywhere($(this).text())
            if (!m) return
            vars.push({ $radio: $(this).find('input[type=radio]'), w: m.w, h: m.h, area: m.w * m.h })
          })
          if (!vars.length) {
            $('#parameter-id-6 option').each(function() {
              var m2 = parseSizeAnywhere($(this).text().trim())
              if (m2) vars.push({ $radio: $(), w: m2.w, h: m2.h, area: m2.w * m2.h, value: $(this).val() })
            })
          }
          if (!vars.length) {
            log('[ATYP] selectCeilOrNearest: no variants')
            return false
          }
 
          // přesná shoda
          for (var i = 0; i < vars.length; i++) {
            if (vars[i].w === inputW && vars[i].h === inputH) {
              if (vars[i].$radio && vars[i].$radio.length) vars[i].$radio.trigger('click')
              else if (typeof vars[i].value !== 'undefined') {
                var $sel0 = $('#parameter-id-6')
                if ($sel0.length) {
                  $sel0.val(vars[i].value).trigger('input').trigger('change')
                  $(document).trigger('ShoptetVariantChanged')
                }
              }
              return true
            }
          }
 
          // „ceil“ — vyber variantu s w>=inputW a h>=inputH; nejmenší přesah vyhrává
          var ge = []
          for (var j = 0; j < vars.length; j++) if (vars[j].w >= inputW && vars[j].h >= inputH) ge.push(vars[j])
          if (ge.length) {
            ge.sort(function(a, b) {
              var da = (a.w - inputW) + (a.h - inputH), db = (b.w - inputW) + (b.h - inputH)
              if (da !== db) return da - db
              var dWa = a.w - inputW, dWb = b.w - inputW
              if (dWa !== dWb) return dWa - dWb
              return a.area - b.area
            })
            if (ge[0].$radio && ge[0].$radio.length) ge[0].$radio.trigger('click')
            else if (typeof ge[0].value !== 'undefined') {
              var $sel1 = $('#parameter-id-6')
              if ($sel1.length) {
                $sel1.val(ge[0].value).trigger('input').trigger('change')
                $(document).trigger('ShoptetVariantChanged')
              }
            }
            return true
          }
 
          // fallback „nejbližší“ (když neexistuje žádná s oběma rozměry >=)
          var best = null, min = Infinity
          for (var k = 0; k < vars.length; k++) {
            var v = vars[k], diff = Math.abs(v.w - inputW) + Math.abs(v.h - inputH)
            if (diff < min ||
              (diff === min && Math.abs(v.w - inputW) < Math.abs((best ? best.w : Infinity) - inputW)) ||
              (diff === min && Math.abs(v.w - inputW) === Math.abs((best ? best.w : Infinity) - inputW) && v.area < (best ? best.area : Infinity))) {
              min = diff
              best = v
            }
          }
          if (best) {
            if (best.$radio && best.$radio.length) best.$radio.trigger('click')
            else if (typeof best.value !== 'undefined') {
              var $sel2 = $('#parameter-id-6')
              if ($sel2.length) {
                $sel2.val(best.value).trigger('input').trigger('change')
                $(document).trigger('ShoptetVariantChanged')
              }
            }
            return true
          }
          return false
        } catch (e) {
          err('[ATYP] selectCeilOrNearest error:', e)
          return false
        }
      }
 
      // === NOVÉ: inline upozornění jako první prvek v .p-info-wrapper ===
      ;(function ensureAtypInlineStyle() {
        if (!document.getElementById('atyp-inline-style')) {
          var css = [
            '.atyp-inline{display:flex;align-items:flex-start;gap:.75rem; order: 4; margin: 0; padding:12px 14px;border:1px solid #bee5eb;background:#d1ecf1;border-radius:6px;box-shadow:0 2px 8px rgba(0,0,0,.05);font-weight:600;line-height:1.35}',
            '.atyp-inline .atyp-icon{flex:0 0 auto;width:20px;height:20px;line-height:20px;text-align:center;font-weight:700}',
            '.atyp-inline .atyp-body{flex:1 1 auto}',
            '.atyp-inline a{text-decoration:underline}',
            '.atyp-inline[data-hidden="1"]{display:none}',
            '.atyp-inline .msg{display:none!important}'
          ].join('')
          var el = document.createElement('style')
          el.id = 'atyp-inline-style'
          el.textContent = css
          document.head.appendChild(el)
        }
      })()
 
      function showAtypAlert() {
        var $wrap = $('.type-detail .p-info-wrapper')
        if (!$wrap.length) {
          warn('[ATYP] .p-info-wrapper nenalezen')
          return
        }
        var $box = $wrap.children('#atyp-inline')
        if (!$box.length) {
          $box = $(
            '<div id="atyp-inline" class="atyp-inline" role="status" aria-live="polite" data-hidden="0">' +
            '<div class="atyp-icon">ℹ️</div>' +
            '<div class="atyp-body">' +
            '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>' +
            '</div>' +
            '</div>'
          )
          $wrap.prepend($box)
        } else {
          $box.find('.msg').remove()
          if (!$box.find('.hint').length) {
            $box.find('.atyp-body').append(
              '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>'
            )
          }
          $box.attr('data-hidden', '0')
        }
        $('#atyp-alert').remove()
      }
 
      function hideAtypAlert() {
        var $box = $('.type-detail .p-info-wrapper').children('#atyp-inline')
        if ($box.length) $box.attr('data-hidden', '1')
        $('#atyp-alert').remove()
      }
 
      ;(function migrateAtypInlineMarkupOnce() {
        var $box = $('.type-detail .p-info-wrapper').children('#atyp-inline')
        if ($box.length) {
          $box.find('.msg').remove()
          if (!$box.find('.hint').length) {
            $box.find('.atyp-body').append(
              '<div class="hint">Tento rozměr vám naceníme individuálně. Prosíme, <a href="/kontakty">kontaktujte nás</a>.</div>'
            )
          }
        }
      })()
 
      function setDetailWrapperHidden(hidden) {
        var $el = $('.type-detail .p-info-wrapper .detail-wrapper')
        if (!$el.length) return
        if (hidden) {
          $el.attr('data-atyp-hidden', '1').css('display', 'none')
        } else {
          if ($el.attr('data-atyp-hidden')) {
            $el.css('display', '').removeAttr('data-atyp-hidden')
          }
        }
      }
 
      function clearLegacyStorageKeys() {
        try {
          if (!window.localStorage) return
          var toDelete = []
          for (var i = 0; i < localStorage.length; i++) {
            var k = localStorage.key(i)
            if (k && k.indexOf(STORAGE_PREFIX) === 0) toDelete.push(k)
          }
          toDelete.forEach(function(k) {
            localStorage.removeItem(k)
          })
          if (toDelete.length) log('[ATYP] cleared legacy localStorage keys:', toDelete.length)
        } catch (e) {
          warn('[ATYP] clearLegacyStorageKeys fail', e)
        }
      }
 
      function setVariantVisibility($row, hasAtyp) {
        var $v = $row.find('.main-link-variant, [data-testid="cartWidgetVariantName"]')
        if (!$v.length) return
        if (hasAtyp) {
          $v.each(function() {
            $(this).attr('data-atyp-hidden', '1').hide()
          })
        } else {
          $v.each(function() {
            var $el = $(this)
            if ($el.attr('data-atyp-hidden') === '1') {
              $el.removeAttr('data-atyp-hidden').show()
            }
          })
        }
      }
 
      function getActiveVariantSize() {
        var txt = $('.choose-parameters-wrap.rozmer .labels-container label.active, .choose-parameters-wrap.rozmer .labels-container label.selected').text().trim()
        if (!txt) {
          var $sel = $('#parameter-id-6')
          if ($sel.length) txt = $sel.find('option:selected').text().trim()
        }
        var m = parseSizeAnywhere(txt)
        return m || null
      }
 
      function getMaxHeightForWidth(width) {
        var list = collectVariantSizes()
        var maxH = null
        for (var i = 0; i < list.length; i++) {
          if (list[i].w === width) {
            if (maxH === null || list[i].h > maxH) maxH = list[i].h
          }
        }
        return maxH
      }
 
      function hasVariantAtLeast(minW, minH) {
        var list = collectVariantSizes()
        for (var i = 0; i < list.length; i++) {
          if (list[i].w >= minW && list[i].h >= minH) return true
        }
        return false
      }
 
      // === Inicializace na detailu matrací (admin + povolené značky + title obsahuje "matrace")
      if ($('body').hasClass('admin-logged') && isAllowedBrand() && isMattressTitle()) {
        log('[ATYP] init on product detail')
        if (!$('#custom-size-picker-style').length) {
          $('head').append('<style id="custom-size-picker-style">#custom-size-picker[data-state="open"]{display:grid!important;opacity:1!important;visibility:visible!important;height:auto!important}#custom-size-picker[data-state="closed"]{display:none!important}.type-detail .master-radio-wrapper{overflow:visible!important}</style>')
        }
 
        // UI prvky (šířka+délka)
        $(
          '<button id="toggle-size-picker" type="button" class="btn">Rozměr na přání</button>' +
          '<div id="custom-size-picker" data-state="closed">' +
          ' <label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>' +
          ' <label><span>délka</span><input type="number" id="input-height" min="0"><span>cm</span></label>' +
          '</div>'
        ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer')
        ensureDomStore()
        var pickerWantedOpen = false
 
        function syncPickerVisualWithState() {
          $('#custom-size-picker').attr('data-state', pickerWantedOpen ? 'open' : 'closed')
        }
 
        function openPicker() {
          pickerWantedOpen = true
          syncPickerVisualWithState()
        }
 
        function closePicker() {
          pickerWantedOpen = false
          syncPickerVisualWithState()
        }
 
        $(document).off('click', '#toggle-size-picker').on('click', '#toggle-size-picker', function(e) {
          e.preventDefault()
          pickerWantedOpen = !pickerWantedOpen
          syncPickerVisualWithState()
          if (pickerWantedOpen) {
            var w = document.getElementById('input-width')
            if (w) setTimeout(function() {
              try {
                w.focus()
              } catch (e) {
              }
            }, 0)
          }
          return false
        })
 
        function mountPickerIfMissing() {
          if (!$('#custom-size-picker').length) {
            $(
              '<div id="custom-size-picker" data-state="closed">' +
              ' <label><span>šířka</span><input type="number" id="input-width" min="0"><span>cm</span></label>' +
              ' <label><span>délka</span><input type="number" id="input-height" min="0"><span>cm</span></label>' +
              '</div>'
            ).insertAfter('.type-detail .master-radio-wrapper .choose-parameters-wrap.rozmer')
            log('[ATYP] mountPickerIfMissing -> mounted')
          }
        }
 
        function forcePickerOpenIfWanted() {
          mountPickerIfMissing()
          if (pickerWantedOpen) $('#custom-size-picker').attr('data-state', 'open')
        }
 
        $(document).on('ShoptetVariantChanged ShoptetDOMUpdated', function() {
          setTimeout(forcePickerOpenIfWanted, 0)
          setTimeout(forcePickerOpenIfWanted, 120)
          setTimeout(forcePickerOpenIfWanted, 360)
        })
        if ('MutationObserver' in window) {
          var mo1 = new MutationObserver(function() {
            setTimeout(forcePickerOpenIfWanted, 0)
          })
          mo1.observe(document.body, { childList: true, subtree: true })
        }
        $(document).off('click', '.choose-parameters-wrap.rozmer .labels-container label')
          .on('click', '.choose-parameters-wrap.rozmer .labels-container label', function(e) {
            if (e.isTrigger) return
            if (!(e.originalEvent && e.originalEvent.isTrusted)) return
            closePicker()
          })
 
        // --- hlavní onInput
        var tmr
 
        function onInput() {
          clearTimeout(tmr)
          tmr = setTimeout(function() {
            try {
              var W = (function() {
                var v = $('#input-width').val()
                return v === '' ? null : parseInt(v, 10)
              })()
              var H = (function() {
                var v = $('#input-height').val()
                return v === '' ? null : parseInt(v, 10)
              })()
              var hasW = typeof W === 'number' && !isNaN(W)
              var hasH = typeof H === 'number' && !isNaN(H)
 
              var maxW = getMaxWidthFromVariants()
              var maxHGlobal = getMaxHeightFromVariants()
 
              var active = getActiveVariantSize()
              var baseWidth = hasW ? W : (active ? active.w : null)
              var maxHForBaseWidth = (baseWidth != null) ? getMaxHeightForWidth(baseWidth) : null
 
              var minW = getMinWidthFromVariants()
              var minH = getMinHeightFromVariants()
 
              var widthTooBig = hasW && (maxW !== null) && (W > maxW)
              var lengthTooBig
              if (hasH) {
                if (baseWidth != null) {
                  lengthTooBig = !hasVariantAtLeast(baseWidth, H)
                } else {
                  lengthTooBig = (maxHGlobal !== null) ? (H > maxHGlobal) : false
                }
              } else {
                lengthTooBig = false
              }
 
              log('[ATYP] dims -> W:', W, 'H:', H,
                '| activeW:', (active ? active.w : null),
                '| baseWidth:', baseWidth,
                '| maxW:', maxW,
                '| maxHForBaseWidth:', maxHForBaseWidth,
                '| maxHGlobal:', maxHGlobal,
                '| widthTooBig:', widthTooBig,
                '| lengthTooBig:', lengthTooBig)
 
              if (widthTooBig || lengthTooBig) {
                showAtypAlert()
                setDetailWrapperHidden(true)
              } else {
                hideAtypAlert()
                setDetailWrapperHidden(false)
              }
 
              // při potvrzené dvojici W/H volíme „ceil nebo nejbližší“ + uložíme vazbu
              if (hasW && hasH) {
                var picked = selectCeilOrNearest(W, H)
                if (picked) {
                  setTimeout(function() {
                    try {
                      var chosen = getActiveVariantSize()
                      if (!chosen) return
                      var cleanName = getCleanProductNameFromH1()
                      var skuNow = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
                      var entry = {
                        width: W, height: H,
                        bindW: chosen.w, bindH: chosen.h,
                        cleanProductName: cleanName,
                        sku: skuNow || '',
                        source: 'ceil-or-nearest'
                      }
                      upsertEntryToCookie(entry)
                      syncDomStoreFromCookie()
                      log('[ATYP] ceil-or-nearest -> saved user dims with bind:', entry)
                    } catch (e) {
                      err('[ATYP] ceil-or-nearest save error:', e)
                    }
                  }, 150)
                }
              }
 
            } catch (e) {
              err('[ATYP] onInput error:', e)
            }
          }, 220)
        }
 
        $('#input-width, #input-height').on('input', onInput)
        setTimeout(onInput, 200)
 
        var ADD_TO_CART_SELECTORS = [
          '.p-to-cart .btn',
          '.product-detail form[action*="cart"] button[type=submit]',
          'form[action*="cart"] .btn[type=submit]',
          '#product-detail-form .btn[type=submit]',
          '.btn-to-cart'
        ].join(',')
        $(document).off('click.atypAdd', ADD_TO_CART_SELECTORS).on('click.atypAdd', ADD_TO_CART_SELECTORS, function() {
          try {
            var cleanName = getCleanProductNameFromH1()
            if (!cleanName) return
            var wRaw = $('#input-width').val(), hRaw = $('#input-height').val()
            var W = wRaw === '' ? null : parseInt(wRaw, 10)
            var H = hRaw === '' ? null : parseInt(hRaw, 10)
 
            if (typeof W === 'number' && !isNaN(W) && typeof H === 'number' && !isNaN(H)) {
              var entryInput = { width: W, height: H, cleanProductName: cleanName, sku: '', source: 'add-to-cart' }
              var minW = getMinWidthFromVariants(), minH = getMinHeightFromVariants()
              if (minW != null && minH != null && (W < minW || H < minH)) {
                var sm = getSmallestVariantByArea()
                if (sm) {
                  entryInput.bindW = sm.w
                  entryInput.bindH = sm.h
                }
              }
              var skuNow = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
              if (skuNow) entryInput.sku = skuNow
              upsertEntryToCookie(entryInput)
              syncDomStoreFromCookie()
              log('[ATYP] saved (input dims) before add-to-cart:', entryInput)
              return
            }
 
            var pickedText = $('.choose-parameters-wrap.rozmer .labels-container label.active, .choose-parameters-wrap.rozmer .labels-container label.selected').text()
            if (!pickedText) {
              var $sel = $('#parameter-id-6')
              if ($sel.length) pickedText = $sel.find('option:selected').text()
            }
            var m = parseSizeAnywhere(pickedText)
            if (m) {
              var skuNow2 = $('.type-detail .p-info-wrapper .p-code .parameter-dependent:visible').text().trim()
              var entryVar = { width: m.w, height: m.h, cleanProductName: cleanName, sku: skuNow2 || '', source: 'add-to-cart' }
              upsertEntryToCookie(entryVar)
              syncDomStoreFromCookie()
              log('[ATYP] saved (variant dims) before add-to-cart:', entryVar)
            }
          } catch (e) {
            err('[ATYP] add-to-cart save error:', e)
          }
        })
      }
 
      function waitFor(selector, opts) {
        opts = opts || {}
        var tries = typeof opts.tries === 'number' ? opts.tries : 60
        var interval = typeof opts.interval === 'number' ? opts.interval : 150
        return new Promise(function(resolve) {
          var left = tries;
          (function tick() {
            if ($(selector).length) return resolve(true)
            if (--left <= 0) return resolve(false)
            setTimeout(tick, interval)
          })()
        })
      }
 
      // === id--16 (rekap / sidebar košíku: dopsat info k položkám) ===
      if ($('body').hasClass('id--16')) {
        (async function() {
          if (!$('#custom-note-style').length) $('head').append('<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>')
          var storedArr = syncDomStoreFromCookie()
          await waitFor('[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item')
          setTimeout(function() {
            var $rows = $('[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item')
            $rows.each(function() {
              var $row = $(this)
 
              function findAtypForCartItem($row, storedArrDomFirst) {
                try {
                  var productName = clean(
                    $row.find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a').first().text() ||
                    $row.find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name').first().text()
                  )
                  var productSlugCandidate = slug(productName)
                  var variantStr = clean(
                    $row.find('[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants').first().text()
                  ) || clean($row.text())
                  var dim = parseSizeAnywhere(variantStr)
                  var itemSku = clean(
                    $row.attr('data-micro-sku') ||
                    $row.find('[data-micro-sku]').attr('data-micro-sku') ||
                    $row.find('.p-code, .product-code, .code, .sku').first().text()
                  )
                  if (itemSku) itemSku = itemSku.trim()
 
                  // 1) Přímá shoda productSlug + rozměr
                  if (productSlugCandidate && dim) {
                    for (var i = 0; i < storedArrDomFirst.length; i++) {
                      var x0 = storedArrDomFirst[i]
                      if (x0.productSlug === productSlugCandidate && x0.width === dim.w && x0.height === dim.h) return x0
                    }
                  }
 
                  // 1a) Bind shoda
                  if (productSlugCandidate && dim) {
                    for (var b = 0; b < storedArrDomFirst.length; b++) {
                      var xb = storedArrDomFirst[b]
                      var sameProdB = (xb.productSlug === productSlugCandidate) || looseMatch(xb.cleanProductName, productName)
                      if (!sameProdB) continue
                      if (xb.bindW && xb.bindH && xb.bindW === dim.w && xb.bindH === dim.h) return xb
                    }
                  }
 
                  // 2) Jméno + (rozměr shodný / prohozený)
                  if (productName) {
                    for (var j = 0; j < storedArrDomFirst.length; j++) {
                      var x1 = storedArrDomFirst[j]
                      var ok = looseMatch(x1.cleanProductName, productName) &&
                        (!dim || ((x1.width === dim.w && x1.height === dim.h) || (x1.width === dim.h && x1.height === dim.w)))
                      if (ok) return x1
                    }
                  }
 
                  // 3) SKU
                  if (itemSku) {
                    if (dim) {
                      for (var m = 0; m < storedArrDomFirst.length; m++) {
                        var x3 = storedArrDomFirst[m]
                        var ok3 = x3.sku && x3.sku.trim() === itemSku &&
                          ((x3.width === dim.w && x3.height === dim.h) || (x3.width === dim.h && x3.height === dim.w))
                        if (ok3) return x3
                      }
                    }
                    var skuMatches = []
                    for (var n = 0; n < storedArrDomFirst.length; n++) {
                      var x4 = storedArrDomFirst[n]
                      if (x4.sku && x4.sku.trim() === itemSku) skuMatches.push(x4)
                    }
                    if (skuMatches.length === 1) return skuMatches[0]
                    if (productName) {
                      for (var p = 0; p < storedArrDomFirst.length; p++) {
                        var x5 = storedArrDomFirst[p]
                        if (x5.sku && x5.sku.trim() === itemSku && looseMatch(x5.cleanProductName, productName)) return x5
                      }
                    }
                  }
 
                  // 4) Jméno + rozměr
                  if (productName && dim) {
                    for (var k = 0; k < storedArrDomFirst.length; k++) {
                      var x2 = storedArrDomFirst[k]
                      var ok2 = looseMatch(x2.cleanProductName, productName) &&
                        ((x2.width === dim.w && x2.height === dim.h) || (x2.width === dim.h && x2.height === dim.w))
                      if (ok2) return x2
                    }
                  }
 
                  // 5) Jméno fallback
                  if (productName) {
                    var sameProd = []
                    for (var q = 0; q < storedArrDomFirst.length; q++) {
                      var x6 = storedArrDomFirst[q]
                      if (looseMatch(x6.cleanProductName, productName) || x6.productSlug === productSlugCandidate) sameProd.push(x6)
                    }
                    var distinct = {}
                    for (var r = 0; r < sameProd.length; r++) distinct[sameProd[r].width + 'x' + sameProd[r].height] = true
                    var keys = Object.keys(distinct)
                    if (!dim && keys.length === 1) return sameProd[0]
                    if (sameProd.length) return sameProd[0]
                  }
 
                  return null
                } catch (e) {
                  err('[ATYP] findAtypForCartItem error:', e)
                  return null
                }
              }
 
              var entry = findAtypForCartItem($row, readDomStore())
              var $name = $row.find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name').first()
              var $mount = $name.length ? $name : $row
 
              // RESET
              $mount.find('.custom-note').remove()
              setVariantVisibility($row, false)
 
              if (!entry) return
 
              var msg = 'Atypický rozměr ' + entry.width + 'x' + entry.height + ' cm'
              var $after = $mount.find('a.main-link, a').first()
              var $note = $('<span class="custom-note atyp-note"></span>').text(msg)
              if ($after.length) {
                $note.insertAfter($after)
              } else {
                $mount.append($note)
              }
 
              setVariantVisibility($row, true)
            })
          }, 80)
        })()
      }
 
      // === id--9 (přehled v košíku – tabulka) ===
      if ($('body').hasClass('id--9')) {
        (async function() {
          if (!$('#custom-note-style').length) $('head').append('<style id="custom-note-style">.custom-note{display:block;margin-top:6px;font-size:13px;opacity:.85}</style>')
 
          function renderCartNotes() {
            syncDomStoreFromCookie()
            var storedArrDom = readDomStore()
 
            function msgOf(e) {
              return 'Atypický rozměr ' + e.width + 'x' + e.height + ' cm'
            }
 
            $('.cart-table tr.removeable, .cart-table tr[data-micro="cartItem"]').each(function() {
              var $tr = $(this)
 
              function findAtypForCartItem($row, storedArrDomFirst) {
                try {
                  var productName = clean(
                    $row.find('a.main-link, [data-micro="cartItemName"] a, .cart-item-name a, .p-name a, .product-name a, .name a').first().text() ||
                    $row.find('[data-micro="cartItemName"], .cart-item-name, .p-name, .product-name, .name').first().text()
                  )
                  var productSlugCandidate = slug(productName)
                  var variantStr = clean(
                    $row.find('[data-micro="cartItemVariant"], .main-link-variant, .p-variant, .variant, .cart-item-variants, .cart-variants, .variant-name, .param-value, .param-row, .cart-params, .product-variants').first().text()
                  ) || clean($row.text())
                  var dim = parseSizeAnywhere(variantStr)
                  var itemSku = clean(
                    $row.attr('data-micro-sku') ||
                    $row.find('[data-micro-sku]').attr('data-micro-sku') ||
                    $row.find('.p-code, .product-code, .code, .sku').first().text()
                  )
                  if (itemSku) itemSku = itemSku.trim()
 
                  if (productSlugCandidate && dim) {
                    for (var i = 0; i < storedArrDomFirst.length; i++) {
                      var x0 = storedArrDomFirst[i]
                      if (x0.productSlug === productSlugCandidate && x0.width === dim.w && x0.height === dim.h) return x0
                    }
                  }
 
                  // Bind shoda
                  if (productSlugCandidate && dim) {
                    for (var b = 0; b < storedArrDomFirst.length; b++) {
                      var xb = storedArrDomFirst[b]
                      var sameProdB = (xb.productSlug === productSlugCandidate) || looseMatch(xb.cleanProductName, productName)
                      if (!sameProdB) continue
                      if (xb.bindW && xb.bindH && xb.bindW === dim.w && xb.bindH === dim.h) return xb
                    }
                  }
 
                  if (productName) {
                    for (var j = 0; j < storedArrDomFirst.length; j++) {
                      var x1 = storedArrDomFirst[j]
                      var ok = looseMatch(x1.cleanProductName, productName) &&
                        (!dim || ((x1.width === dim.w && x1.height === dim.h) || (x1.width === dim.h && x1.height === dim.w)))
                      if (ok) return x1
                    }
                  }
 
                  if (itemSku) {
                    if (dim) {
                      for (var m = 0; m < storedArrDomFirst.length; m++) {
                        var x3 = storedArrDomFirst[m]
                        var ok3 = x3.sku && x3.sku.trim() === itemSku &&
                          ((x3.width === dim.w && x3.height === dim.h) || (x3.width === dim.h && x3.height === dim.w))
                        if (ok3) return x3
                      }
                    }
                    var skuMatches = []
                    for (var n = 0; n < storedArrDomFirst.length; n++) {
                      var x4 = storedArrDomFirst[n]
                      if (x4.sku && x4.sku.trim() === itemSku) skuMatches.push(x4)
                    }
                    if (skuMatches.length === 1) return skuMatches[0]
                    if (productName) {
                      for (var p = 0; p < storedArrDomFirst.length; p++) {
                        var x5 = storedArrDomFirst[p]
                        if (x5.sku && x5.sku.trim() === itemSku && looseMatch(x5.cleanProductName, productName)) return x5
                      }
                    }
                  }
 
                  if (productName && dim) {
                    for (var k = 0; k < storedArrDomFirst.length; k++) {
                      var x2 = storedArrDomFirst[k]
                      var ok2 = looseMatch(x2.cleanProductName, productName) &&
                        ((x2.width === dim.w && x2.height === dim.h) || (x2.width === dim.h && x2.height === dim.w))
                      if (ok2) return x2
                    }
                  }
 
                  if (productName) {
                    var sameProd = []
                    for (var q = 0; q < storedArrDomFirst.length; q++) {
                      var x6 = storedArrDomFirst[q]
                      if (looseMatch(x6.cleanProductName, productName) || x6.productSlug === productSlugCandidate) sameProd.push(x6)
                    }
                    var distinct = {}
                    for (var r = 0; r < sameProd.length; r++) distinct[sameProd[r].width + 'x' + sameProd[r].height] = true
                    var keys = Object.keys(distinct)
                    if (!dim && keys.length === 1) return sameProd[0]
                    if (sameProd.length) return sameProd[0]
                  }
 
                  return null
                } catch (e) {
                  err('[ATYP] findAtypForCartItem(cart) error:', e)
                  return null
                }
              }
 
              var entry = findAtypForCartItem($tr, storedArrDom)
              var $nameCell = $tr.find('[data-micro="cartItemName"], .p-name, .cart-item-name, .product-name, .name').first()
              var $mount = $nameCell.length ? $nameCell : $tr
 
              // RESET
              $mount.find('.custom-note').remove()
              setVariantVisibility($tr, false)
 
              if (!entry) return
 
              var $link = $mount.find('a, .main-link').first()
              var $note = $('<div class="custom-note atyp-note"></div>').text(msgOf(entry))
              if ($link.length) {
                $note.insertAfter($link)
              } else {
                $mount.append($note)
              }
 
              setVariantVisibility($tr, true)
            })
          }
 
          var ok = await waitFor('.cart-table tr.removeable, .cart-table tr[data-micro="cartItem"]')
          if (ok) setTimeout(renderCartNotes, 100)
          $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function() {
            setTimeout(renderCartNotes, 80)
          })
          var target = document.querySelector('#content') || document.body
          if (target && 'MutationObserver' in window) {
            var mo3 = new MutationObserver(function() {
              setTimeout(renderCartNotes, 50)
            })
            mo3.observe(target, { childList: true, subtree: true })
          }
        })()
      }
 
      // === id--19 (widget / mini-košík apod.) ===
      if ($('body').hasClass('id--19')) {
        (async function() {
          await waitFor('[data-testid="cartWidgetVariantName"], .main-link-variant, [data-micro="cartItem"], .cart-items .cart-item')
 
          function refreshVariantHides() {
            var $rows = $(
              '[data-micro="cartItem"], .cart-items .cart-item, .summary-table tr, .order-summary .item, .recap-items .item, [data-testid="cartWidgetItem"], .cart-widget-item, .cart-widget .item, tr'
            )
            $rows.each(function() {
              var $row = $(this)
              var hasAtyp = $row.find('.atyp-note').length > 0
              setVariantVisibility($row, hasAtyp)
            })
          }
 
          refreshVariantHides()
 
          $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function() {
            setTimeout(refreshVariantHides, 50)
          })
          if ('MutationObserver' in window) {
            var mo = new MutationObserver(function() {
              setTimeout(refreshVariantHides, 50)
            })
            mo.observe(document.body, { childList: true, subtree: true })
          }
        })()
      }
 
      // === id--17 (pokladna: POZNÁMKA) – OTEVŘÍT a propsat hodnotu PŘÍMO Z COOKIES do #remark (jen poslední, aktuální session, add-to-cart) ===
      if ($('body').hasClass('id--17')) {
        function _clean(t) {
          return String(t || '').replace(/\s+/g, ' ').trim()
        }
 
        function _slug(s) {
          s = String(s || '')
          try {
            s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
          } catch (e) {
          }
          return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
        }
 
        function _loadLatestFromCookie() {
          try {
            var raw = readCookie(COOKIE_NAME)
            if (!raw) return []
            var arr = JSON.parse(raw)
            if (!Array.isArray(arr)) return []
            arr.sort(function(a, b) {
              return (b.savedAt || 0) - (a.savedAt || 0)
            })
            return arr
          } catch (e) {
            return []
          }
        }
 
        function _ensureNoteOpen() {
          var $toggle = $('#add-note')
          var $wrap = $('#note')
          if ($toggle.length && !$toggle.prop('checked')) {
            $toggle.prop('checked', true).trigger('change')
          }
          if ($wrap.length) $wrap.removeClass('js-hidden').addClass('visible')
        }
 
        function _buildText() {
          var list = _loadLatestFromCookie()
          if (!list.length) return ''
 
          // Jen aktuální session + add-to-cart
          var pool = list.filter(function(x) {
            return x && x.sessionId === SESSION_ID && x.source === 'add-to-cart'
          })
          if (!pool.length) return ''
 
          // dedupe na produkt – už by tam stejně měl být jen poslední kus díky upsertu
          var seen = Object.create(null), picked = []
          for (var i = 0; i < pool.length; i++) {
            var it = pool[i]
            if (!it || !it.cleanProductName || !it.width || !it.height) continue
            var key = (it.productSlug || _slug(_clean(it.cleanProductName)))
            if (seen[key]) continue
            seen[key] = 1
            picked.push(it)
          }
 
          return picked.map(function(x) {
            return 'Atypický rozměr ' + x.cleanProductName + ': ' + x.width + 'x' + x.height + ' cm'
          }).join('\n')
        }
 
        function _fillRemark() {
          var $remark = $('#remark')
          if (!$remark.length) return
          var txt = _buildText()
          if (!txt) return
          _ensureNoteOpen()
          $remark.val(txt)
        }
 
        setTimeout(_fillRemark, 350)
        $(document).on('ShoptetCartUpdated ShoptetCartContentLoaded ShoptetDOMUpdated', function() {
          setTimeout(_fillRemark, 120)
        })
      }
 
    })
  })()
**/

  // END

})


// typeDetail
// podmínkaPostele
// vzorkyZdarma
$(document).ready(function () {
  if ($('body').hasClass('type-detail')) {
    const hasPostele = $('.breadcrumbs [itemprop="name"]').toArray().some(el => {
      return $(el).text().trim() === 'Postele'
    })

    if (hasPostele) {
      const bannerHtml = $(`
        <div class="sample-banner">
          <div class="sample-banner__content">
            <div class="sample-banner__image">
              <img src="/user/documents/upload/new-vzorek.png?v3" alt="" />
            </div>
            <div class="sample-banner__text">
              <h3><a href="#" class="highlight">Vzorek ZDARMA</a> až k vám domů</h3>
              <p>Sdělte nám, jaké vzorky chcete zaslat. Zanechte nám své údaje pro doručení a my vám je do pár dní <strong>ZDARMA zašleme</strong></p>

            </div>
            <div class="sample-banner__action">
              <a href="#vybrat-vzorky" class="btn btn-primary open-sample-modal">VYBRAT VZORKY</a>
            </div>
          </div>
        </div>
      `)

      if (window.innerWidth >= 768) {
        // Desktop: vložit za .master-radio-wrapper
        if ($('.master-radio-wrapper').length) {
          bannerHtml.insertAfter('.master-radio-wrapper')
        } else {
          // záloha – pokud prvek chybí
          bannerHtml.insertAfter('.product-inner')
        }
      } else {
        // Mobil: vložit nad .add-to-cart
        if ($('.add-to-cart').length) {
          bannerHtml.insertBefore('.add-to-cart')
        } else {
          // záloha – pokud prvek chybí
          bannerHtml.prependTo('.product-inner')
        }
      }

      // Otevření/uzavření modálu
      $(document).on('click', '.open-sample-modal', function (e) {
        e.preventDefault()
        $('#sampleModal').fadeIn()
      })

      $(document).on('click', '.modal-close', function () {
        $('#sampleModal').fadeOut()
      })
    }
  }




})


